/* eslint-disable */
/*
* ============================================================================
* ATTENTION: THIS IS AN AUTO-GENERATED FILE
* ============================================================================
* 
* This file was automatically generated through the API route
* 
* ============================================================================
*/
import { AnyMySqlColumn, bigint, binary, boolean, char, check, date, datetime, decimal, foreignKey, index, int, json, longtext, mediumint, mysqlEnum, mysqlSchema, mysqlTable, primaryKey, smallint, text, timestamp, tinyint, uniqueIndex, varchar } from "drizzle-orm/mysql-core";
import { sql } from "drizzle-orm";


// #region AppDB
/* ================================== AppDB =================================== */
const AppDB = mysqlSchema("AppDB");

export const Contractors = AppDB.table("Contractors", {
	ID: smallint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).notNull().references(() => Jobs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	CompanyName: varchar({ length: 255 }).notNull(),
	CompanyShortName: varchar({ length: 100 }).notNull(),
	CompanyRole: varchar({ length: 255 }).notNull(),
	Description: varchar({ length: 1024 }).notNull(),
	Active: tinyint().notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references((): AnyMySqlColumn => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("JobID-TeamHandsSubcontrators_idx").on(table.JobID),
	index("ModifiedBy-Subcontractors_idx").on(table.ModifiedBy),
]);

export const ImportLog = AppDB.table("ImportLog", {
	ID: mediumint().autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).notNull().references(() => Jobs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	FileNameUploaded: varchar({ length: 100 }).notNull(),
	FileNameStored: varchar({ length: 100 }),
	FileNameGCSPath: varchar({ length: 255 }),
	UploadUserID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onUpdate: "cascade" } ),
	UploadTime: datetime({ mode: 'string' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
	ImportUserID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onUpdate: "cascade" } ),
	ImportTime: datetime({ mode: 'string' }),
	Type: varchar({ length: 50 }).notNull(),
	StatusID: tinyint().notNull().references(() => Ref_ImportStatuses.ID, { onUpdate: "cascade" } ),
	ImportResults: json(),
	isFileDeleted: tinyint().default(0).notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ImportUserID-ImportLog_idx").on(table.ImportUserID),
	index("JobID-ImportLog_idx").on(table.JobID),
	index("ModifiedBy-ImportLog_idx").on(table.ModifiedBy),
	index("StatusID-ImportLog_idx").on(table.StatusID),
	index("Type-ImportLog_idx").on(table.Type),
	index("UploadUserID-ImportLog_idx").on(table.UploadUserID),
]);

export const Jobs = AppDB.table("Jobs", {
	ID: smallint({ unsigned: true }).autoincrement().primaryKey(),
	PGID: smallint({ unsigned: true }).notNull().references(() => PGs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	JobNumber: varchar({ length: 8 }).default("Trig Gen").notNull(),
	JobName: varchar({ length: 255 }).notNull(),
	ShortName: varchar({ length: 40 }).notNull(),
	ClientName: varchar({ length: 255 }).notNull(),
	Owner: varchar({ length: 255 }).notNull(),
	StreetAddress: varchar({ length: 255 }).notNull(),
	City: varchar({ length: 255 }).notNull(),
	State: char({ length: 2 }).notNull(),
	Zipcode: char({ length: 5 }).notNull(),
	Latitude: decimal({ mode: 'string', precision: 10, scale: 7 }),
	Logitude: decimal({ mode: 'string', precision: 10, scale: 7 }),
	Active: tinyint().notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references((): AnyMySqlColumn => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ModifiedBy-Jobs_idx").on(table.ModifiedBy),
	index("PGID-Jobs_idx").on(table.PGID),
]);

export const Log_ClientErrors = AppDB.table("Log_ClientErrors", {
	ID: int().autoincrement().primaryKey(),
	URL: varchar({ length: 1024 }),
	UserID: mediumint({ unsigned: true }),
	SessionData: json(),
	ErrorText: longtext(),
	ExtraData: json(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
});

export const Log_EventExecution = AppDB.table("Log_EventExecution", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	EventName: varchar({ length: 255 }).notNull(),
	ExecutionTime: timestamp({ mode: 'string' }).defaultNow(),
	SchemaName: varchar({ length: 64 }).notNull(),
	AffectedRows: mediumint({ unsigned: true }),
	ExecutionStatus: mysqlEnum(["Success","Failure","Suspended"]).notNull(),
	ErrorMessage: text(),
},
(table) => [
	index("idx_event_name").on(table.EventName),
	index("idx_execution_time").on(table.ExecutionTime),
]);

export const Ref_AccountReqStatuses = AppDB.table("Ref_AccountReqStatuses", {
	ID: tinyint().primaryKey(),
	Label: varchar({ length: 45 }),
});

export const Ref_Crafts = AppDB.table("Ref_Crafts", {
	ID: tinyint().autoincrement().primaryKey(),
	Label: varchar({ length: 255 }).notNull(),
	ColorCodes: char({ length: 9 }),
});

export const Ref_Disciplines = AppDB.table("Ref_Disciplines", {
	ID: tinyint().autoincrement().primaryKey(),
	Label: varchar({ length: 255 }).notNull(),
	CraftID: tinyint().references(() => Ref_Crafts.ID, { onUpdate: "cascade" } ),
},
(table) => [
	index("CraftID-Ref_Disciplines_idx").on(table.CraftID),
]);

export const Ref_ImportStatuses = AppDB.table("Ref_ImportStatuses", {
	ID: tinyint().autoincrement().primaryKey(),
	Label: varchar({ length: 45 }).notNull(),
});

export const Ref_Methods = AppDB.table("Ref_Methods", {
	ID: tinyint().autoincrement().primaryKey(),
	Label: varchar({ length: 255 }).notNull(),
});

export const Ref_Prog_ActivityRejections = AppDB.table("Ref_Prog_ActivityRejections", {
	ID: tinyint().autoincrement().primaryKey(),
	Label: varchar({ length: 255 }).notNull(),
});

export const Ref_Prog_ActivityStatuses = AppDB.table("Ref_Prog_ActivityStatuses", {
	ID: tinyint().autoincrement().primaryKey(),
	Label: varchar({ length: 255 }).notNull(),
});

export const Ref_Prog_Ques = AppDB.table("Ref_Prog_Ques", {
	ID: tinyint().autoincrement().primaryKey(),
	Label: varchar({ length: 255 }).notNull(),
});

export const Ref_Prog_ReportGroups = AppDB.table("Ref_Prog_ReportGroups", {
	ID: smallint().autoincrement().primaryKey(),
	Schema: varchar({ length: 10 }).notNull(),
	TableName: varchar({ length: 40 }),
	ColumnName: varchar({ length: 50 }),
	ColumnNameFull: varchar({ length: 50 }),
	ColumnNameShort: varchar({ length: 50 }),
	ColumnContentDescription: varchar({ length: 255 }),
	ColumnContentDefaultValue: varchar({ length: 50 }),
});

export const Ref_Roles = AppDB.table("Ref_Roles", {
	ID: tinyint({ unsigned: true }).autoincrement().primaryKey(),
	Label: varchar({ length: 255 }).notNull(),
	RoleLevel: varchar({ length: 10 }).notNull(),
});

export const Ref_Shifts = AppDB.table("Ref_Shifts", {
	ID: tinyint().autoincrement().primaryKey(),
	Label: varchar({ length: 255 }).notNull(),
});

export const Ref_TS_AllocationTypes = AppDB.table("Ref_TS_AllocationTypes", {
	ID: tinyint().primaryKey(),
	Label: varchar({ length: 45 }),
});

export const Ref_TS_Statuses = AppDB.table("Ref_TS_Statuses", {
	ID: tinyint().primaryKey(),
	Label: varchar({ length: 45 }),
});

export const Sessions = AppDB.table("Sessions", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	SessionID: char({ length: 32 }).default("Trig Gen").notNull(),
	CSRFToken: char({ length: 32 }).default("Trig Gen").notNull(),
	TimeCreated: timestamp({ mode: 'string' }).defaultNow(),
	TimeLastAccess: timestamp({ mode: 'string' }),
	TimeExpires: timestamp({ mode: 'string' }),
	SessionTimeoutSeconds: mediumint().default(21600).notNull(),
	UserID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	RequestCount: mediumint({ unsigned: true }).default(1).notNull(),
	Attributes: json().notNull(),
},
(table) => [
	index("SessionID-Sessions_idx").on(table.SessionID),
	index("TimeExpires_idx").on(table.TimeExpires),
	index("UserID-Sessions_idx").on(table.UserID),
	index("UserID_TimeExpires_idx").on(table.UserID, table.TimeExpires),
]);

export const SettingsGlobal = AppDB.table("SettingsGlobal", {
	Label: varchar({ length: 255 }).primaryKey(),
	Value: varchar({ length: 255 }).notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ModifiedBy-SettingsGlobal_idx").on(table.ModifiedBy),
]);

export const SettingsUser = AppDB.table("SettingsUser", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	UserID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	Label: varchar({ length: 255 }).notNull(),
	Value: json().notNull(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow().notNull(),
},
(table) => [
	uniqueIndex("COMBO-UserID/Label-SettingsUser_UQ").on(table.UserID, table.Label),
	index("UserID-UserSettings_idx").on(table.UserID),
]);

export const Signatures = AppDB.table("Signatures", {
	ID: int({ unsigned: true }).autoincrement().primaryKey(),
	Signature: text().notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references((): AnyMySqlColumn => Users.ID, { onUpdate: "cascade" } ),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
});

export const TeamHands = AppDB.table("TeamHands", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	EmpID: int({ unsigned: true }).notNull(),
	ScanCode: varchar({ length: 45 }),
	TeamID: mediumint({ unsigned: true }).references(() => Teams.ID, { onUpdate: "cascade" } ),
	FirstName: varchar({ length: 50 }),
	MiddleName: varchar({ length: 50 }),
	LastName: varchar({ length: 50 }),
	EmpIDName: varchar({ length: 250 }).generatedAlwaysAs(sql`concat(\`LastName\`,_utf8mb4\', \',\`FirstName\`,_utf8mb4\' \',coalesce(\`MiddleName\`,_utf8mb4\'\'),_utf8mb4\' - \',\`EmpID\`)`, { mode: "virtual" }),
	ModifiedBy: mediumint().notNull(),
	ActiveEmployee: tinyint().notNull(),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	uniqueIndex("EmpID_UQ").on(table.EmpID),
	index("EmpIDName-TeamHands_idx").on(table.EmpIDName),
	uniqueIndex("ScanCode_UQ").on(table.ScanCode),
	index("TeamID-TeamHands_idx").on(table.TeamID),
]);

export const TeamHandsREV = AppDB.table("TeamHandsREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	EmpID: int({ unsigned: true }),
	ScanCode: varchar({ length: 45 }),
	TeamID: mediumint({ unsigned: true }),
	FirstName: varchar({ length: 50 }),
	MiddleName: varchar({ length: 50 }),
	LastName: varchar({ length: 50 }),
	ModifiedBy: mediumint(),
	ActiveEmployee: tinyint(),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-TeamHandsREV").on(table.OrgID),
]);

export const TeamHandsSubcontractors = AppDB.table("TeamHandsSubcontractors", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	SubcontractorID: smallint({ unsigned: true }).notNull().references(() => Contractors.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	EmpID: varchar({ length: 100 }).notNull(),
	ScanCode: varchar({ length: 100 }),
	TeamID: mediumint({ unsigned: true }).references(() => Teams.ID, { onUpdate: "cascade" } ),
	FirstName: varchar({ length: 50 }),
	MiddleName: varchar({ length: 50 }),
	LastName: varchar({ length: 50 }),
	EmpIDName: varchar({ length: 250 }).generatedAlwaysAs(sql`concat(\`LastName\`,_utf8mb4\', \',\`FirstName\`,_utf8mb4\' \',coalesce(\`MiddleName\`,_utf8mb4\'\'),_utf8mb4\' - \',\`EmpID\`)`, { mode: "virtual" }),
	ModifiedBy: mediumint().notNull(),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	uniqueIndex("CompanyID/EmpID_UQ").on(table.SubcontractorID, table.EmpID),
	index("EmpIDName-TeamHandsSubcontractors_idx").on(table.EmpIDName),
	uniqueIndex("ScanCode_UQ").on(table.ScanCode),
	index("TeamID-TeamHandsSubcontractors_idx").on(table.TeamID),
]);

export const TeamHandsSubcontractorsREV = AppDB.table("TeamHandsSubcontractorsREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	SubcontractorID: smallint({ unsigned: true }),
	EmpID: varchar({ length: 100 }),
	ScanCode: varchar({ length: 100 }),
	TeamID: mediumint({ unsigned: true }),
	FirstName: varchar({ length: 50 }),
	MiddleName: varchar({ length: 50 }),
	LastName: varchar({ length: 50 }),
	ModifiedBy: mediumint(),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-TeamHandsSubcontractorsREV").on(table.OrgID),
]);

export const UserAccountReqs = AppDB.table("UserAccountReqs", {
	ID: mediumint().autoincrement().primaryKey(),
	ReqStatusID: tinyint().default(1).notNull().references(() => Ref_AccountReqStatuses.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	UserReq: json().notNull(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow().notNull(),
},
(table) => [
	index("ReqStatusID-UserAccountReqs_idx").on(table.ReqStatusID),
]);

export const UserAPIKeys = AppDB.table("UserAPIKeys", {
	ID: mediumint().autoincrement().primaryKey(),
	APIKey: char({ length: 32 }).default("Trig Gen").notNull(),
	Name: varchar({ length: 255 }).notNull(),
	UserID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	TimeExpires: timestamp({ mode: 'string' }).defaultNow().notNull(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("APIKey-UserAPIKeys_idx").on(table.APIKey),
	index("UserID-UserAPIKeys_idx").on(table.UserID),
]);

export const UserCreds = AppDB.table("UserCreds", {
	UserID: mediumint({ unsigned: true }).primaryKey().references(() => Users.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	Password: char({ length: 67 }).notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ModifiedBy-UserCreds_idx").on(table.ModifiedBy),
]);

export const UserDisciplines = AppDB.table("UserDisciplines", {
	ID: mediumint().autoincrement().primaryKey(),
	UserID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	DisciplineID: tinyint().notNull().references(() => Ref_Disciplines.ID, { onUpdate: "cascade" } ),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onUpdate: "cascade" } ),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("DisciplineID_UserDisciplines_idx").on(table.DisciplineID),
	index("ModifiedBy_UserDisciplines_idx").on(table.ModifiedBy),
	index("UserID-UserCraft_idx").on(table.UserID),
]);

export const UserJobs = AppDB.table("UserJobs", {
	ID: mediumint().autoincrement().primaryKey(),
	UserID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	JobID: smallint({ unsigned: true }).notNull().references(() => Jobs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	uniqueIndex("COMBO-UserID/JobID-UserJobs_UQ").on(table.UserID, table.JobID),
	index("JobID-UserJobs_idx").on(table.JobID),
	index("ModifiedBy-UserJobs_idx").on(table.ModifiedBy),
	index("UserID-UserJobs_idx").on(table.UserID),
]);

export const UserRoles = AppDB.table("UserRoles", {
	ID: mediumint().autoincrement().primaryKey(),
	UserID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	RoleID: tinyint({ unsigned: true }).notNull().references(() => Ref_Roles.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	uniqueIndex("COMBO-UserID/RoleID-UserRoles_UQ").on(table.UserID, table.RoleID),
	index("ModifiedBy-UserRoles_idx").on(table.ModifiedBy),
	index("RolesID-UserRoles_idx").on(table.RoleID),
	index("UserID-UserRoles_idx").on(table.UserID),
]);

export const Whitelist_APIKeyTables = AppDB.table("Whitelist_APIKeyTables", {
	Schema: varchar({ length: 10 }).notNull(),
	Table: varchar({ length: 255 }).notNull(),
},
(table) => [
	primaryKey({ columns: [table.Table, table.Schema] }),]);

export const Whitelist_TableMethodRoles = AppDB.table("Whitelist_TableMethodRoles", {
	Schema: varchar({ length: 10 }).notNull(),
	Table: varchar({ length: 255 }).notNull(),
	MethodID: tinyint().notNull().references(() => Ref_Methods.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	RoleID: tinyint({ unsigned: true }).notNull().references(() => Ref_Roles.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
},
(table) => [
	primaryKey({ columns: [table.Schema, table.Table, table.MethodID, table.RoleID] }),	index("MethodID-Whitelist_TableMethodRoles_idx").on(table.MethodID),
	index("RoleID-Whitelist_TableMethodRoles_idx").on(table.RoleID),
]);

export const Users = AppDB.table("Users", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	EmployeeId: varchar({ length: 50 }).notNull(),
	FirstName: varchar({ length: 50 }).notNull(),
	MiddleName: varchar({ length: 50 }),
	LastName: varchar({ length: 50 }).notNull(),
	NickName: varchar({ length: 50 }),
	UserName: varchar({ length: 50 }),
	FullName: varchar({ length: 250 }).generatedAlwaysAs(sql`concat_ws(_utf8mb4\' \',\`FirstName\`,nullif(\`MiddleName\`,_utf8mb4\'\'),\`LastName\`)`, { mode: "virtual" }),
	Email: varchar({ length: 250 }).notNull(),
	CraftID: tinyint().notNull().references(() => Ref_Crafts.ID, { onUpdate: "cascade" } ),
	DefaultJobID: smallint({ unsigned: true }).notNull().references((): AnyMySqlColumn => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	SignatureID: int({ unsigned: true }).references((): AnyMySqlColumn => Signatures.ID, { onUpdate: "cascade" } ),
	isActive: tinyint().notNull(),
	ContractorID: smallint({ unsigned: true }).default(1).notNull().references((): AnyMySqlColumn => Contractors.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	ModifiedBy: mediumint({ unsigned: true }).notNull(),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("COMBO-Job/PG/Discipline-Users").on(table.DefaultJobID, table.CraftID),
	index("CraftID-Users_idx").on(table.CraftID),
	index("DefaultJobID-Users_idx").on(table.DefaultJobID),
	uniqueIndex("Email_UQ").on(table.Email),
	uniqueIndex("EmployeeId_UQ").on(table.EmployeeId),
	index("FullName-Users").on(table.FullName),
	index("ModifiedBy-Users_idx").on(table.ModifiedBy),
	index("SubContractorID-Users_idx").on(table.ContractorID),
	uniqueIndex("UserName_UQ").on(table.UserName),
	foreignKey({
		columns: [table.ModifiedBy],
		foreignColumns: [table.ID],
		name: "ModifiedBy-Users"
	}).onUpdate("cascade").onDelete("restrict"),
]);

export const PGs = AppDB.table("PGs", {
	ID: smallint({ unsigned: true }).autoincrement().primaryKey(),
	PGName: varchar({ length: 40 }).default("Trig Gen"),
	Title: varchar({ length: 255 }).notNull(),
	Description: varchar({ length: 1024 }).notNull(),
	TMSCollectionID: int({ unsigned: true }),
	Active: tinyint().notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ModifiedBy-PGs_idx").on(table.ModifiedBy),
	uniqueIndex("TMSCollectionID_UNIQUE").on(table.TMSCollectionID),
]);

export const Ref_ImportKeys = AppDB.table("Ref_ImportKeys", {
	ID: smallint().autoincrement().primaryKey(),
	Table: varchar({ length: 45 }),
	Column: varchar({ length: 45 }),
	ExampleSet: json(),
	Rules: json(),
	DefaultValue: varchar({ length: 45 }),
	Description: varchar({ length: 2048 }),
	ValidOptions: json(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
});

export const Ref_Prog_ActivityTypes = AppDB.table("Ref_Prog_ActivityTypes", {
	ID: smallint({ unsigned: true }).autoincrement().primaryKey(),
	Discipline: varchar({ length: 45 }).notNull(),
	ActivityTypeCode: varchar({ length: 10 }).notNull(),
	ActivitySubTypeCode: varchar({ length: 10 }).notNull(),
	Label: varchar({ length: 255 }).notNull(),
	LabelShort: varchar({ length: 45 }),
},
(table) => [
	uniqueIndex("Combo-Discipline/Type/Subtype-Ref_Prog_ActivityTypes").on(table.Discipline, table.ActivityTypeCode, table.ActivitySubTypeCode),
]);

export const Teams = AppDB.table("Teams", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	TMSCrewID: mediumint({ unsigned: true }),
	TeamNumber: smallint({ unsigned: true }).notNull(),
	TeamName: varchar({ length: 100 }),
	PGID: smallint({ unsigned: true }).notNull().references(() => PGs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	PrimaryJobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ProjectManagerID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	ConstructionManagerID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	SiteManagerID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	AreaManagerID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	SuperintendentID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	GeneralForemanID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	ForemanID: mediumint({ unsigned: true }).references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	CraftID: tinyint().notNull().references(() => Ref_Crafts.ID, { onUpdate: "cascade" } ),
	ShiftID: tinyint().default(1).notNull().references(() => Ref_Shifts.ID, { onUpdate: "cascade" } ),
	ContractorID: smallint({ unsigned: true }).default(1).notNull().references(() => Contractors.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	isActive: tinyint().notNull(),
	is3rdPartyApprovable: tinyint().default(0).notNull(),
	isCustomName: tinyint().default(0).notNull(),
	isPrintable: tinyint().default(1).notNull(),
	DateCreate: date({ mode: 'string' }).notNull(),
	DateActivated: date({ mode: 'string' }).notNull(),
	DateDeactivate: date({ mode: 'string' }),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("AreaManagerID_idx").on(table.AreaManagerID),
	index("COMBO-ID/Rev-Teams_idx").on(table.ID, table.Rev),
	index("COMBO-Job/Craft/Super-Teams_idx").on(table.SuperintendentID),
	index("COMBO-Job/isActive/Craft-Teams_idx").on(table.PrimaryJobID, table.isActive, table.CraftID),
	index("ConstructionManagerID_idx").on(table.ConstructionManagerID),
	index("CraftID-Teams_idx").on(table.CraftID),
	uniqueIndex("Foreman_UQ").on(table.ForemanID),
	index("ForemanID_idx").on(table.ForemanID),
	index("GeneralForemanID_idx").on(table.GeneralForemanID),
	index("ModifiedBy_idx").on(table.ModifiedBy),
	index("PGID_idx").on(table.PGID),
	index("PrimaryJobID-Teams_idx").on(table.PrimaryJobID),
	index("ProjectManagerID_idx").on(table.ProjectManagerID),
	index("ShiftID-Teams_idx").on(table.ShiftID),
	index("SiteManagerID_idx").on(table.SiteManagerID),
	index("SubcontractorID-Teams_idx").on(table.ContractorID),
	index("SuperintendentID_idx").on(table.SuperintendentID),
	uniqueIndex("TMSTeamID_UNIQUE").on(table.TMSCrewID),
]);

export const TeamsREV = AppDB.table("TeamsREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }).references(() => Teams.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	TMSCrewID: mediumint({ unsigned: true }),
	TeamNumber: smallint({ unsigned: true }),
	TeamName: varchar({ length: 100 }),
	PGID: smallint({ unsigned: true }),
	PrimaryJobID: smallint({ unsigned: true }),
	ProjectManagerID: mediumint({ unsigned: true }),
	ConstructionManagerID: mediumint({ unsigned: true }),
	SiteManagerID: mediumint({ unsigned: true }),
	AreaManagerID: mediumint({ unsigned: true }),
	SuperintendentID: mediumint({ unsigned: true }),
	GeneralForemanID: mediumint({ unsigned: true }),
	ForemanID: mediumint({ unsigned: true }),
	CraftID: tinyint(),
	ShiftID: tinyint(),
	SubcontractorID: smallint({ unsigned: true }),
	isActive: tinyint(),
	is3rdPartyApprovable: tinyint(),
	isCustomName: tinyint(),
	isPrintable: tinyint(),
	DateCreate: date({ mode: 'string' }),
	DateActivated: date({ mode: 'string' }),
	DateDeactivate: date({ mode: 'string' }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("AreaManagerID_idx").on(table.AreaManagerID),
	index("Combo-OrgID/Rev_idx").on(table.OrgID, table.Rev),
	index("Combo-PGID/TeamNumber/Rev").on(table.PGID, table.TeamNumber, table.Rev),
	index("ConstructionManagerID_idx").on(table.ConstructionManagerID),
	index("ForemanID_idx").on(table.ForemanID),
	index("GeneralForemanID_idx").on(table.GeneralForemanID),
	index("OrgID-TeamsREV_idx").on(table.OrgID),
	index("ProjectManagerID_idx").on(table.ProjectManagerID),
	index("SiteManagerID_idx").on(table.SiteManagerID),
	index("SuperintendentID_idx").on(table.SuperintendentID),
]);

export const TeamOrgHistory_View = AppDB.table("TeamOrgHistory_View", {


TeamID: mediumint({ unsigned: true }),

TeamRev: smallint(),

PGID: smallint({ unsigned: true }),

TeamNumber: smallint({ unsigned: true }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),
});

// #endregion


// #region PG100
/* ================================== PG100 =================================== */
export const Landing_CostCodes = mysqlTable("Landing_CostCodes", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	Job: varchar({ length: 255 }),
	SubJob: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	EWO: varchar({ length: 255 }),
	FullCC: varchar({ length: 255 }).generatedAlwaysAs(sql`concat_ws(_utf8mb4\'.\',\`Job\`,\`SubJob\`,\`Phase\`,\`CostCode\`,nullif(\`EWO\`,_utf8mb4\'\'))`, { mode: "virtual" }),
	Description: varchar({ length: 1025 }),
	Catagory: varchar({ length: 255 }),
	AllocationTypeID: varchar({ length: 255 }),
	isDirect: varchar({ length: 255 }),
	isLabor: varchar({ length: 255 }),
	isActive: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_CostCodes_idx").on(table.JobID),
]);

export const Landing_TSBalance = mysqlTable("Landing_TSBalance", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	ShiftEmpId: varchar({ length: 255 }),
	EmployeeStartTime: datetime({ mode: 'string' }),
	EmployeeStopTime: datetime({ mode: 'string' }),
	EmployeeUpt: varchar({ length: 255 }),
	EmployeeWorkedHrs: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TSBalance_idx").on(table.JobID),
]);

export const MOTD = mysqlTable("MOTD", {
	ID: smallint({ unsigned: true }).autoincrement().primaryKey(),
	MOTD: varchar({ length: 2048 }),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ModifiedBy-MOTD_idx").on(table.ModifiedBy),
]);

export const Prog_FAComments = mysqlTable("Prog_FAComments", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	ActivityGUID: binary({ length: 16 }).notNull().references(() => Prog_FA.GUID, { onDelete: "cascade", onUpdate: "cascade" } ),
	Comment: varchar({ length: 1024 }).notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ActivityGUID-Prog_FAComments_idx").on(table.ActivityGUID),
	index("ModifiedBy-Prog_FAComments_idx").on(table.ModifiedBy),
]);

export const Prog_FAPipeSpools = mysqlTable("Prog_FAPipeSpools", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	ActivityGUID: binary({ length: 16 }).notNull().references(() => Prog_FA.GUID, { onDelete: "cascade", onUpdate: "cascade" } ),
	SpoolNumber: varchar({ length: 50 }).notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ActivityGUID-Prog_FAPipeSpools_idx").on(table.ActivityGUID),
	index("ModifiedBy-Prog_FAPipeSpools_idx").on(table.ModifiedBy),
]);

export const Prog_FAPipeWelds = mysqlTable("Prog_FAPipeWelds", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	ActivityGUID: binary({ length: 16 }).notNull().references(() => Prog_FA.GUID, { onDelete: "cascade", onUpdate: "cascade" } ),
	WeldNumber: varchar({ length: 45 }).notNull(),
	WeldSpool1: varchar({ length: 45 }),
	WeldSpool2: varchar({ length: 45 }),
	WeldDrawingNumber: varchar({ length: 45 }),
	WeldLineNumber: varchar({ length: 45 }),
	WeldSheetNumber: varchar({ length: 3 }),
	WeldLineSpec: varchar({ length: 45 }),
	WeldStencil: varchar({ length: 16 }),
	WeldSize: decimal({ mode: 'string', precision: 5, scale: 2 }),
	WeldThickness: varchar({ length: 16 }),
	WeldType: varchar({ length: 45 }),
	WeldPosition: varchar({ length: 16 }),
	WeldMaterial: varchar({ length: 45 }),
	WeldProcedure: varchar({ length: 45 }),
	WeldComplete: tinyint(),
	WeldShared: tinyint(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ActivityGUID-Prog_FAPipeWelds_idx").on(table.ActivityGUID),
	index("ModifiedBy-ProgFAPipeWelds_idx").on(table.ModifiedBy),
]);

export const Prog_SubmissionDetails = mysqlTable("Prog_SubmissionDetails", {
	GUID: binary({ length: 16 }).default(sql`uuid_to_bin(uuid())`).primaryKey(),
	JobID: smallint({ unsigned: true }).notNull().references(() => Jobs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	RecordNumber: mediumint({ unsigned: true }).autoincrement().notNull(),
	Os: varchar({ length: 25 }),
	OsVersion: varchar({ length: 25 }),
	Browser: varchar({ length: 25 }),
	BrowserVersion: varchar({ length: 25 }),
	FormName: varchar({ length: 25 }),
	FormVersion: varchar({ length: 25 }),
	SubmittingUserID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	TeamID: mediumint({ unsigned: true }).notNull().references(() => Teams.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	TeamRev: smallint({ unsigned: true }).notNull(),
	Note: varchar({ length: 2048 }),
	Latitude: decimal({ mode: 'string', precision: 10, scale: 7 }),
	Longitude: decimal({ mode: 'string', precision: 10, scale: 7 }),
	StartTime: timestamp({ mode: 'string' }).notNull(),
	CompleteTime: timestamp({ mode: 'string' }),
	SignatureID: int({ unsigned: true }).references(() => Signatures.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-CrewID/CrewREV-Prog_SubmissionDetials").on(table.TeamID, table.TeamRev),
	index("JobID-Prog_SubmissionDetails_idx").on(table.JobID),
	index("ModifiedBy-Prog_SubmissionDetails_idx").on(table.ModifiedBy),
	uniqueIndex("RecordNumber_UNIQUE").on(table.RecordNumber),
	index("SubmittingUserID-ProgSubmissionDetails_idx").on(table.SubmittingUserID),
]);

export const Prog_SubmissionDetailsREV = mysqlTable("Prog_SubmissionDetailsREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	GUID: binary({ length: 16 }),
	JobID: smallint({ unsigned: true }),
	RecordNumber: mediumint({ unsigned: true }),
	Os: varchar({ length: 25 }),
	OsVersion: varchar({ length: 25 }),
	Browser: varchar({ length: 25 }),
	BrowserVersion: varchar({ length: 25 }),
	FormName: varchar({ length: 25 }),
	FormVersion: varchar({ length: 25 }),
	SubmittingUserID: mediumint({ unsigned: true }),
	TeamID: mediumint({ unsigned: true }),
	TeamRev: smallint({ unsigned: true }),
	Note: varchar({ length: 2048 }),
	Latitude: decimal({ mode: 'string', precision: 10, scale: 7 }),
	Longitude: decimal({ mode: 'string', precision: 10, scale: 7 }),
	StartTime: timestamp({ mode: 'string' }),
	CompleteTime: timestamp({ mode: 'string' }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("GUID-Prog_SubmissionDetailsREV").on(table.GUID),
]);

export const Prog_TrackerSpecsCivil = mysqlTable("Prog_TrackerSpecsCivil", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	Drawing: varchar({ length: 100 }).notNull(),
	SheetNumber: varchar({ length: 3 }).notNull(),
	DrawingRev: varchar({ length: 100 }).default("0").notNull(),
	DetailDrawing: varchar({ length: 100 }).default("0").notNull(),
	DetailRev: varchar({ length: 100 }).default("0").notNull(),
	DetailName: varchar({ length: 100 }).default("0").notNull(),
	Description: varchar({ length: 255 }).notNull(),
	ActivityType: varchar({ length: 45 }).notNull(),
	ActivitySubType: varchar({ length: 45 }).notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-AT/AST-Prog_TrackerCivilSpecs").on(table.ActivityType, table.ActivitySubType),
]);

export const Prog_TrackerSpecsCivilREV = mysqlTable("Prog_TrackerSpecsCivilREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	Drawing: varchar({ length: 100 }),
	SheetNumber: varchar({ length: 3 }),
	DrawingRev: varchar({ length: 100 }),
	DetailDrawing: varchar({ length: 100 }),
	DetailRev: varchar({ length: 100 }),
	DetailName: varchar({ length: 100 }),
	Description: varchar({ length: 255 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsCivilREV").on(table.OrgID),
]);

export const Prog_TrackerSpecsPipe = mysqlTable("Prog_TrackerSpecsPipe", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ComponentNumber: varchar({ length: 100 }).default("0").notNull(),
	PID: varchar({ length: 100 }).default("0").notNull(),
	LineNumber: varchar({ length: 100 }).default("0").notNull(),
	Drawing: varchar({ length: 100 }).notNull(),
	SheetNumber: varchar({ length: 3 }).notNull(),
	DrawingRev: varchar({ length: 100 }).default("0").notNull(),
	Description: varchar({ length: 255 }).notNull(),
	ActivityType: varchar({ length: 45 }).notNull(),
	ActivitySubType: varchar({ length: 45 }).notNull(),
	ClientMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	PerformanceMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }).default('0.00').notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-AT/AST-Prog_TrackerPipeSpecs").on(table.ActivityType, table.ActivitySubType),
]);

export const Prog_TrackerSpecsPipeREV = mysqlTable("Prog_TrackerSpecsPipeREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	ComponentNumber: varchar({ length: 100 }),
	PID: varchar({ length: 100 }),
	LineNumber: varchar({ length: 100 }),
	Drawing: varchar({ length: 100 }),
	SheetNumber: varchar({ length: 3 }),
	DrawingRev: varchar({ length: 100 }),
	Description: varchar({ length: 255 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ClientMaterialSpec: varchar({ length: 45 }),
	PerformanceMaterialSpec: varchar({ length: 45 }),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsPipeREV").on(table.OrgID),
]);

export const SettingsJob = mysqlTable("SettingsJob", {
	ID: smallint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).notNull().references(() => Jobs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	Label: varchar({ length: 255 }).notNull(),
	Value1: varchar({ length: 255 }),
	Value2: decimal({ mode: 'string', precision: 6, scale: 3 }),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	uniqueIndex("Combo_JobID/Label_UNIQUE").on(table.JobID, table.Label),
	index("JobID_idx").on(table.JobID),
	index("ModifiedBy-SettingsJob_idx").on(table.ModifiedBy),
]);

export const SettingsPG = mysqlTable("SettingsPG", {
	Label: varchar({ length: 255 }).primaryKey(),
	Value: varchar({ length: 255 }).notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ModifiedBy-SettingsPG_idx").on(table.ModifiedBy),
]);

export const TMS_CostCodes = mysqlTable("TMS_CostCodes", {
	ID: smallint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	TMSID: int({ unsigned: true }),
	Job: varchar({ length: 45 }).notNull(),
	SubJob: varchar({ length: 45 }).notNull(),
	Phase: varchar({ length: 45 }).notNull(),
	CostCode: varchar({ length: 45 }).notNull(),
	EWO: varchar({ length: 45 }),
	FullCC: varchar({ length: 255 }).generatedAlwaysAs(sql`concat_ws(_utf8mb4\'.\',\`Job\`,\`SubJob\`,\`Phase\`,\`CostCode\`,nullif(\`EWO\`,_utf8mb4\'\'))`, { mode: "virtual" }),
	Description: varchar({ length: 1024 }),
	isDirect: tinyint().default(1).notNull(),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	uniqueIndex("FullCC-TMS_CostCodes_UNIQUE").on(table.FullCC),
	index("JobID-TMS_CostCodes_idx").on(table.JobID),
	uniqueIndex("TMSID_UNIQUE").on(table.TMSID),
]);

export const TS_CCGCCs = mysqlTable("TS_CCGCCs", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	CCGID: smallint({ unsigned: true }).notNull().references(() => TS_CCGs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	CCID: smallint({ unsigned: true }).notNull().references(() => TS_CostCodes.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onUpdate: "cascade" } ),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("CCGID-TS_CCGCCs_idx").on(table.CCGID),
	uniqueIndex("COMBO-CCGID/CCID-Unique").on(table.CCGID, table.CCID),
	index("ModifiedBy-TS_CCGCCs_idx").on(table.ModifiedBy),
]);

export const TS_CCGs = mysqlTable("TS_CCGs", {
	ID: smallint({ unsigned: true }).autoincrement().primaryKey(),
	Name: varchar({ length: 50 }).notNull(),
	Description: varchar({ length: 1024 }).notNull(),
	JobID: smallint({ unsigned: true }).notNull(),
	JobDefaultCCG: smallint({ unsigned: true }),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	uniqueIndex("JobDefaultCCG_UNIQUE").on(table.JobDefaultCCG),
	index("JobID-TS_CCGs_idx").on(table.JobID),
	index("ModifiedBy-TS_CCGs_idx").on(table.ModifiedBy),
	check("JobDefaultCCG-CHECK_vs_JobID-TS_CCGs", sql`((\`JobDefaultCCG\` is null) or (\`JobDefaultCCG\` = \`JobID\`))`),
]);

export const TS_CCGTeams = mysqlTable("TS_CCGTeams", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	CCGID: smallint({ unsigned: true }).notNull().references(() => TS_CCGs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	TeamID: mediumint({ unsigned: true }).notNull().references(() => Teams.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onUpdate: "cascade" } ),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("CCGID-TS_CCGTeams_idx").on(table.CCGID),
	uniqueIndex("COMBO-CCGID/TeamID-Unique").on(table.CCGID, table.TeamID),
	index("ModifiedBy-TS_CCGTeams_idx").on(table.ModifiedBy),
]);

export const TS_CostCodes = mysqlTable("TS_CostCodes", {
	ID: smallint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Job: varchar({ length: 45 }).notNull(),
	SubJob: varchar({ length: 45 }).notNull(),
	Phase: varchar({ length: 45 }).notNull(),
	CostCode: varchar({ length: 45 }).notNull(),
	EWO: varchar({ length: 45 }),
	FullCC: varchar({ length: 255 }).generatedAlwaysAs(sql`concat_ws(_utf8mb4\'.\',\`Job\`,\`SubJob\`,\`Phase\`,\`CostCode\`,nullif(\`EWO\`,_utf8mb4\'\'))`, { mode: "virtual" }),
	Description: varchar({ length: 1024 }),
	Category: varchar({ length: 45 }),
	AllocationTypeID: tinyint().notNull().references(() => Ref_TS_AllocationTypes.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	isDirect: tinyint().notNull(),
	isLabor: tinyint().notNull(),
	isActive: tinyint().notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	uniqueIndex("FullCC-TS_CostCodes-UNIQUE").on(table.FullCC),
	index("JobID-TS_CostCodes_idx").on(table.JobID),
	index("ModifiedBy-TS_CostCodes_idx").on(table.ModifiedBy),
	index("Ref_TS_AllocationTypes").on(table.AllocationTypeID),
]);

export const TS_ShiftDetails = mysqlTable("TS_ShiftDetails", {
	GUID: binary({ length: 16 }).default(sql`uuid_to_bin(uuid())`).primaryKey(),
	JobID: smallint({ unsigned: true }).notNull().references(() => Jobs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	RecordNumber: mediumint({ unsigned: true }).autoincrement().notNull(),
	Os: varchar({ length: 25 }),
	OsVersion: varchar({ length: 25 }),
	Browser: varchar({ length: 25 }),
	BrowserVersion: varchar({ length: 25 }),
	FormName: varchar({ length: 25 }),
	FormVersion: varchar({ length: 25 }),
	SubmittingUserID: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	TeamID: mediumint({ unsigned: true }).notNull().references(() => Teams.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	TeamRev: smallint({ unsigned: true }).notNull(),
	ShiftDate: date({ mode: 'string' }).notNull(),
	ShiftStart: datetime({ mode: 'string' }).notNull(),
	ShiftStop: datetime({ mode: 'string' }).notNull(),
	ShiftUPT: smallint().notNull(),
	Notes: varchar({ length: 1024 }),
	StatusID: tinyint().default(0).notNull().references(() => Ref_TS_Statuses.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	StartTime: timestamp({ mode: 'string' }).defaultNow().notNull(),
	CompleteTime: timestamp({ mode: 'string' }).notNull(),
	ReceivedTime: timestamp({ mode: 'string' }),
	Locked: mediumint({ unsigned: true }).references(() => Users.ID, { onUpdate: "cascade" } ),
	SignatureID: int({ unsigned: true }).references(() => Signatures.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-TeamID/ShiftStart/StatusID-TS_Details").on(table.TeamID, table.ShiftStart, table.StatusID),
	index("JobID-TS_Details_idx").on(table.JobID),
	index("Locked-TS_Details_idx").on(table.Locked),
	index("ModifiedBy-TS_Details_idx").on(table.ModifiedBy),
	uniqueIndex("RecordNumber-TS_Details").on(table.RecordNumber),
	index("Ref_TS_Statuses-TS_Details_idx").on(table.StatusID),
	index("SubmittingUserID_idx").on(table.SubmittingUserID),
	index("TeamID-TS_Details_idx").on(table.TeamID),
]);

export const TS_ShiftDetailsREV = mysqlTable("TS_ShiftDetailsREV", {
	ID: int({ unsigned: true }).autoincrement().primaryKey(),
	GUID: binary({ length: 16 }),
	JobID: smallint({ unsigned: true }),
	RecordNumber: mediumint({ unsigned: true }),
	Os: varchar({ length: 25 }),
	OsVersion: varchar({ length: 25 }),
	Browser: varchar({ length: 25 }),
	BrowserVersion: varchar({ length: 25 }),
	FormName: varchar({ length: 25 }),
	FormVersion: varchar({ length: 25 }),
	SubmittingUserID: mediumint({ unsigned: true }),
	TeamID: mediumint({ unsigned: true }),
	TeamRev: smallint({ unsigned: true }),
	ShiftDate: date({ mode: 'string' }),
	ShiftStart: datetime({ mode: 'string' }),
	ShiftStop: datetime({ mode: 'string' }),
	ShiftUPT: smallint(),
	Notes: varchar({ length: 1024 }),
	StatusID: tinyint(),
	StartTime: timestamp({ mode: 'string' }),
	CompleteTime: timestamp({ mode: 'string' }),
	ReceivedTime: timestamp({ mode: 'string' }),
	Locked: mediumint({ unsigned: true }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
});

export const Prog_TrackerSpecsTARREV = mysqlTable("Prog_TrackerSpecsTARREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	WorkOrder: varchar({ length: 100 }).default("0"),
	Sequence: smallint().default(0),
	Drawing: varchar({ length: 100 }),
	SheetNumber: varchar({ length: 3 }),
	DrawingRev: varchar({ length: 100 }).default("0"),
	Description: varchar({ length: 255 }),
	WorkDisciplineID: tinyint(),
	ScheduleResource: varchar({ length: 100 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ClientMaterialSpec: varchar({ length: 45 }).default("0"),
	PerformanceMaterialSpec: varchar({ length: 45 }).default("0"),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsTARREV").on(table.OrgID),
]);

export const TS_ShiftEmployeesREV = mysqlTable("TS_ShiftEmployeesREV", {
	ID: int({ unsigned: true }).autoincrement().primaryKey(),
	GUID: binary({ length: 16 }),
	RecordNumber: mediumint({ unsigned: true }),
	ShiftGUID: binary({ length: 16 }),
	HandID: mediumint({ unsigned: true }),
	EmpShiftStart: datetime({ mode: 'string' }),
	EmpShiftStop: datetime({ mode: 'string' }),
	EmpShiftUPT: smallint(),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
});

export const TS_ShiftEntriesREV = mysqlTable("TS_ShiftEntriesREV", {
	ID: int({ unsigned: true }).autoincrement().primaryKey(),
	GUID: binary({ length: 16 }),
	RecordNumber: mediumint({ unsigned: true }),
	ShiftEmpGUID: binary({ length: 16 }),
	CCID: smallint({ unsigned: true }),
	Hours: decimal({ mode: 'string', precision: 4, scale: 2 }),
	Percent: decimal({ mode: 'string', precision: 3, scale: 2 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
});

export const TS_ShiftEmployees = mysqlTable("TS_ShiftEmployees", {
	GUID: binary({ length: 16 }).default(sql`uuid_to_bin(uuid())`).primaryKey(),
	RecordNumber: mediumint({ unsigned: true }).autoincrement().notNull(),
	ShiftGUID: binary({ length: 16 }).notNull().references(() => TS_ShiftDetails.GUID, { onDelete: "cascade", onUpdate: "cascade" } ),
	HandID: mediumint({ unsigned: true }).notNull().references(() => TeamHands.ID, { onUpdate: "cascade" } ),
	EmpShiftStart: datetime({ mode: 'string' }).notNull(),
	EmpShiftStop: datetime({ mode: 'string' }).notNull(),
	EmpShiftUPT: smallint().notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ModifiedBy-TS_ShiftEmployees_idx").on(table.ModifiedBy),
	uniqueIndex("RecordNumber_UNIQUE").on(table.RecordNumber),
	index("ShiftGUID-TS_ShiftEmployees_idx").on(table.ShiftGUID),
]);

export const TS_ShiftEntries = mysqlTable("TS_ShiftEntries", {
	GUID: binary({ length: 16 }).default(sql`uuid_to_bin(uuid())`).primaryKey(),
	RecordNumber: mediumint({ unsigned: true }).autoincrement().notNull(),
	ShiftEmpGUID: binary({ length: 16 }).notNull().references(() => TS_ShiftEmployees.GUID, { onDelete: "cascade", onUpdate: "cascade" } ),
	CCID: smallint({ unsigned: true }).notNull().references(() => TS_CostCodes.ID, { onUpdate: "cascade" } ),
	Hours: decimal({ mode: 'string', precision: 4, scale: 2 }),
	Percent: decimal({ mode: 'string', precision: 3, scale: 2 }),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("CCID-TS_CostCodes_idx").on(table.CCID),
	index("ModifiedBy-TS_ShiftEntries_idx").on(table.ModifiedBy),
	uniqueIndex("RecordNumber_UNIQUE").on(table.RecordNumber),
	index("ShiftEmpGUID-TS_ShiftEntries_idx").on(table.ShiftEmpGUID),
]);

export const Prog_TrackerSpecsElectCable = mysqlTable("Prog_TrackerSpecsElectCable", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	CableTag: varchar({ length: 100 }).default("0").notNull(),
	From: varchar({ length: 100 }).default("0").notNull(),
	To: varchar({ length: 100 }).default("0").notNull(),
	Description: varchar({ length: 100 }).default("0").notNull(),
	FromDescription: varchar({ length: 100 }).default("0").notNull(),
	ToDescription: varchar({ length: 100 }).default("0").notNull(),
	WorkDiscipline: varchar({ length: 45 }).default("0").notNull(),
	TypeSpec: varchar({ length: 45 }).default("0").notNull(),
	Reel: varchar({ length: 45 }).default("0").notNull(),
	ActivityType: varchar({ length: 45 }).notNull(),
	ActivitySubType: varchar({ length: 45 }).notNull(),
	ActivityClass: varchar({ length: 45 }).default("0").notNull(),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }).default('0.00').notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-AT/AST-Prog_TrackerSpecsElectCable").on(table.ActivityType, table.ActivitySubType),
]);

export const Prog_TrackerSpecsElectCableREV = mysqlTable("Prog_TrackerSpecsElectCableREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	CableTag: varchar({ length: 100 }),
	From: varchar({ length: 100 }),
	To: varchar({ length: 100 }),
	Description: varchar({ length: 100 }),
	FromDescription: varchar({ length: 100 }),
	ToDescription: varchar({ length: 100 }),
	WorkDiscipline: varchar({ length: 45 }),
	TypeSpec: varchar({ length: 45 }),
	Reel: varchar({ length: 45 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ActivityClass: varchar({ length: 45 }),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsElectCableREV").on(table.OrgID),
]);

export const Prog_TrackerSpecsElectInst = mysqlTable("Prog_TrackerSpecsElectInst", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ComponentNumber: varchar({ length: 100 }).default("0").notNull(),
	ComponentDescription: varchar({ length: 100 }).default("0").notNull(),
	Cable1: varchar({ length: 100 }).default("0").notNull(),
	Cable2: varchar({ length: 100 }).default("0").notNull(),
	Box1: varchar({ length: 100 }).default("0").notNull(),
	Box2: varchar({ length: 100 }).default("0").notNull(),
	Description: varchar({ length: 100 }).default("0").notNull(),
	TypeSpec: varchar({ length: 45 }).default("0").notNull(),
	ActivityType: varchar({ length: 45 }).notNull(),
	ActivitySubType: varchar({ length: 45 }).notNull(),
	ActivityClass: varchar({ length: 45 }).default("0").notNull(),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }).default('0.00').notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-AT/AST-Prog_TrackerSpecsElectInst").on(table.ActivityType, table.ActivitySubType),
]);

export const Prog_TrackerSpecsElectTray = mysqlTable("Prog_TrackerSpecsElectTray", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ComponentNumber: varchar({ length: 100 }).default("0").notNull(),
	From: varchar({ length: 100 }).default("0").notNull(),
	To: varchar({ length: 100 }).default("0").notNull(),
	ComponentDescription: varchar({ length: 100 }).default("0").notNull(),
	FromDescription: varchar({ length: 100 }).default("0").notNull(),
	ToDescription: varchar({ length: 100 }).default("0").notNull(),
	Description: varchar({ length: 100 }).default("0").notNull(),
	TypeSpec: varchar({ length: 45 }).default("0").notNull(),
	ActivityType: varchar({ length: 45 }).notNull(),
	ActivitySubType: varchar({ length: 45 }).notNull(),
	ActivityClass: varchar({ length: 45 }).default("0").notNull(),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }).default('0.00').notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-AT/AST-Prog_TrackerSpecsElectTray").on(table.ActivityType, table.ActivitySubType),
]);

export const Prog_TrackerSpecsElectTrayREV = mysqlTable("Prog_TrackerSpecsElectTrayREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	ComponentNumber: varchar({ length: 100 }),
	From: varchar({ length: 100 }),
	To: varchar({ length: 100 }),
	ComponentDescription: varchar({ length: 100 }),
	FromDescription: varchar({ length: 100 }),
	ToDescription: varchar({ length: 100 }),
	Description: varchar({ length: 100 }),
	TypeSpec: varchar({ length: 45 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ActivityClass: varchar({ length: 45 }),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsElectTrayREV").on(table.OrgID),
]);

export const Prog_TrackerSpecsElectGeneral = mysqlTable("Prog_TrackerSpecsElectGeneral", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ComponentNumber: varchar({ length: 100 }).default("0").notNull(),
	From: varchar({ length: 100 }).default("0").notNull(),
	To: varchar({ length: 100 }).default("0").notNull(),
	ComponentDescription: varchar({ length: 100 }).default("0").notNull(),
	FromDescription: varchar({ length: 100 }).default("0").notNull(),
	ToDescription: varchar({ length: 100 }).default("0").notNull(),
	Description: varchar({ length: 100 }).default("0").notNull(),
	TypeSpec: varchar({ length: 45 }).default("0").notNull(),
	ActivityType: varchar({ length: 45 }).notNull(),
	ActivitySubType: varchar({ length: 45 }).notNull(),
	ActivityClass: varchar({ length: 45 }).default("0").notNull(),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }).default('0.00').notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-AT/AST-Prog_TrackerSpecsElectGeneral").on(table.ActivityType, table.ActivitySubType),
]);

export const Prog_TrackerSpecsElectGeneralREV = mysqlTable("Prog_TrackerSpecsElectGeneralREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	ComponentNumber: varchar({ length: 100 }),
	From: varchar({ length: 100 }),
	To: varchar({ length: 100 }),
	ComponentDescription: varchar({ length: 100 }),
	FromDescription: varchar({ length: 100 }),
	ToDescription: varchar({ length: 100 }),
	Description: varchar({ length: 100 }),
	TypeSpec: varchar({ length: 45 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ActivityClass: varchar({ length: 45 }),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsElectGeneralREV").on(table.OrgID),
]);

export const Prog_TrackerSpecsElectInstREV = mysqlTable("Prog_TrackerSpecsElectInstREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	ComponentNumber: varchar({ length: 100 }),
	ComponentDescription: varchar({ length: 100 }),
	Cable1: varchar({ length: 100 }),
	Cable2: varchar({ length: 100 }),
	Box1: varchar({ length: 100 }),
	Box2: varchar({ length: 100 }),
	Description: varchar({ length: 100 }),
	TypeSpec: varchar({ length: 45 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ActivityClass: varchar({ length: 45 }),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsElectInstREV").on(table.OrgID),
]);

export const Prog_TrackerSpecsInsulation = mysqlTable("Prog_TrackerSpecsInsulation", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ComponentNumber: varchar({ length: 100 }).default("0").notNull(),
	PID: varchar({ length: 100 }).default("0").notNull(),
	LineNumber: varchar({ length: 100 }).default("0").notNull(),
	Drawing: varchar({ length: 100 }).notNull(),
	SheetNumber: varchar({ length: 3 }).notNull(),
	DrawingRev: varchar({ length: 100 }).default("0").notNull(),
	Description: varchar({ length: 255 }).notNull(),
	ClientMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	PerformanceMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	PipeDiameter: decimal({ mode: 'string', precision: 5, scale: 2 }).default('0.00').notNull(),
	InsulationThickness: decimal({ mode: 'string', precision: 5, scale: 2 }).default('0.00').notNull(),
	ActivityType: varchar({ length: 45 }).notNull(),
	ActivitySubType: varchar({ length: 45 }).notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-AT/AST-Prog_TrackerSpecsInsulation").on(table.ActivityType, table.ActivitySubType),
]);

export const Prog_TrackerSpecsInsulationREV = mysqlTable("Prog_TrackerSpecsInsulationREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	ComponentNumber: varchar({ length: 100 }),
	PID: varchar({ length: 100 }),
	LineNumber: varchar({ length: 100 }),
	Drawing: varchar({ length: 100 }),
	SheetNumber: varchar({ length: 3 }),
	DrawingRev: varchar({ length: 100 }),
	Description: varchar({ length: 255 }),
	ClientMaterialSpec: varchar({ length: 45 }),
	PerformanceMaterialSpec: varchar({ length: 45 }),
	PipeDiameter: decimal({ mode: 'string', precision: 5, scale: 2 }),
	InsulationThickness: decimal({ mode: 'string', precision: 5, scale: 2 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsInsulationREV").on(table.OrgID),
]);

export const Prog_TrackerSpecsTAR = mysqlTable("Prog_TrackerSpecsTAR", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	WorkOrder: varchar({ length: 100 }).default("0").notNull(),
	Sequence: smallint().default(0).notNull(),
	Drawing: varchar({ length: 100 }).notNull(),
	SheetNumber: varchar({ length: 3 }).notNull(),
	DrawingRev: varchar({ length: 100 }).default("0").notNull(),
	Description: varchar({ length: 255 }).notNull(),
	WorkDisciplineID: tinyint().notNull().references(() => Ref_Disciplines.ID, { onUpdate: "cascade" } ),
	ScheduleResource: varchar({ length: 100 }).notNull(),
	ActivityType: varchar({ length: 45 }).notNull(),
	ActivitySubType: varchar({ length: 45 }).notNull(),
	ClientMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	PerformanceMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-AT/AST-Prog_TrackerSpecsTAR").on(table.ActivityType, table.ActivitySubType),
	index("WorkDisciplineID-Prog_TrackerSpecsTAR_idx").on(table.WorkDisciplineID),
]);

export const Prog_TrackerSpecsElectConduit = mysqlTable("Prog_TrackerSpecsElectConduit", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ComponentNumber: varchar({ length: 100 }).default("0").notNull(),
	ComponentDescription: varchar({ length: 100 }).default("0").notNull(),
	Description: varchar({ length: 100 }).default("0").notNull(),
	TypeSpec: varchar({ length: 45 }).default("0").notNull(),
	ActivityType: varchar({ length: 45 }).notNull(),
	ActivitySubType: varchar({ length: 45 }).notNull(),
	ActivityClass: varchar({ length: 45 }).default("0").notNull(),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }).default('0.00').notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-AT/AST-Prog_TrackerSpecsElectConduit").on(table.ActivityType, table.ActivitySubType),
]);

export const Prog_TrackerSpecsElectConduitREV = mysqlTable("Prog_TrackerSpecsElectConduitREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	ComponentNumber: varchar({ length: 100 }),
	ComponentDescription: varchar({ length: 100 }),
	Description: varchar({ length: 100 }),
	TypeSpec: varchar({ length: 45 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ActivityClass: varchar({ length: 45 }),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsElectConduitREV").on(table.OrgID),
]);

export const Landing_TrackerCivil = mysqlTable("Landing_TrackerCivil", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	Drawing: varchar({ length: 255 }),
	SheetNumber: varchar({ length: 255 }),
	DrawingRev: varchar({ length: 255 }),
	DetailDrawing: varchar({ length: 255 }),
	DetailRev: varchar({ length: 255 }),
	DetailName: varchar({ length: 255 }),
	Description: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerCivil_idx").on(table.JobID),
	index("UID-Landing_TrackerCivil_idx").on(table.UID),
]);

export const Landing_TrackerElectCable = mysqlTable("Landing_TrackerElectCable", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	CableTag: varchar({ length: 255 }),
	From: varchar({ length: 255 }),
	To: varchar({ length: 255 }),
	Description: varchar({ length: 255 }),
	FromDescription: varchar({ length: 255 }),
	ToDescription: varchar({ length: 255 }),
	WorkDiscipline: varchar({ length: 255 }),
	TypeSpec: varchar({ length: 255 }),
	Reel: varchar({ length: 255 }),
	ActivityClass: varchar({ length: 255 }),
	Size: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerElectCable_idx").on(table.JobID),
	index("UID-Landing_TrackerElectCable_idx").on(table.UID),
]);

export const Landing_TrackerElectConduit = mysqlTable("Landing_TrackerElectConduit", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	ComponentNumber: varchar({ length: 255 }),
	ComponentDescription: varchar({ length: 255 }),
	Description: varchar({ length: 255 }),
	TypeSpec: varchar({ length: 255 }),
	ActivityClass: varchar({ length: 255 }),
	Size: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerElectConduit_idx").on(table.JobID),
	index("UID-Landing_TrackerElectConduit_idx").on(table.UID),
]);

export const Landing_TrackerElectGeneral = mysqlTable("Landing_TrackerElectGeneral", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	ComponentNumber: varchar({ length: 255 }),
	From: varchar({ length: 255 }),
	To: varchar({ length: 255 }),
	ComponentDescription: varchar({ length: 255 }),
	FromDescription: varchar({ length: 255 }),
	ToDescription: varchar({ length: 255 }),
	Description: varchar({ length: 255 }),
	TypeSpec: varchar({ length: 255 }),
	ActivityClass: varchar({ length: 255 }),
	Size: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerElectGeneral_idx").on(table.JobID),
	index("UID-Landing_TrackerElectGeneral_idx").on(table.UID),
]);

export const Landing_TrackerElectInst = mysqlTable("Landing_TrackerElectInst", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	ComponentNumber: varchar({ length: 255 }),
	ComponentDescription: varchar({ length: 255 }),
	Cable1: varchar({ length: 255 }),
	Cable2: varchar({ length: 255 }),
	Box1: varchar({ length: 255 }),
	Box2: varchar({ length: 255 }),
	Description: varchar({ length: 255 }),
	TypeSpec: varchar({ length: 255 }),
	ActivityClass: varchar({ length: 255 }),
	Size: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerElectInst_idx").on(table.JobID),
	index("UID-Landing_TrackerElectInst_idx").on(table.UID),
]);

export const Landing_TrackerElectTray = mysqlTable("Landing_TrackerElectTray", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	ComponentNumber: varchar({ length: 255 }),
	From: varchar({ length: 255 }),
	To: varchar({ length: 255 }),
	ComponentDescription: varchar({ length: 255 }),
	FromDescription: varchar({ length: 255 }),
	ToDescription: varchar({ length: 255 }),
	Description: varchar({ length: 255 }),
	TypeSpec: varchar({ length: 255 }),
	ActivityClass: varchar({ length: 255 }),
	Size: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerElectTray_idx").on(table.JobID),
	index("UID-Landing_TrackerElectTray_idx").on(table.UID),
]);

export const Landing_TrackerInsulation = mysqlTable("Landing_TrackerInsulation", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	ComponentNumber: varchar({ length: 255 }),
	PID: varchar({ length: 255 }),
	LineNumber: varchar({ length: 255 }),
	Drawing: varchar({ length: 255 }),
	SheetNumber: varchar({ length: 255 }),
	DrawingRev: varchar({ length: 255 }),
	Description: varchar({ length: 255 }),
	ClientMaterialSpec: varchar({ length: 255 }),
	PerformanceMaterialSpec: varchar({ length: 255 }),
	PipeDiameter: varchar({ length: 255 }),
	InsulationThickness: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerInsulation_idx").on(table.JobID),
	index("UID-Landing_TrackerInsulation_idx").on(table.UID),
]);

export const Landing_TrackerPipe = mysqlTable("Landing_TrackerPipe", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	ComponentNumber: varchar({ length: 255 }),
	PID: varchar({ length: 255 }),
	LineNumber: varchar({ length: 255 }),
	Drawing: varchar({ length: 255 }),
	SheetNumber: varchar({ length: 255 }),
	DrawingRev: varchar({ length: 255 }),
	Description: varchar({ length: 255 }),
	ClientMaterialSpec: varchar({ length: 255 }),
	PerformanceMaterialSpec: varchar({ length: 255 }),
	Size: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerPipe_idx").on(table.JobID),
	index("UID-Landing_TrackerPipe_idx").on(table.UID),
]);

export const Landing_TrackerTAR = mysqlTable("Landing_TrackerTAR", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	WorkOrder: varchar({ length: 255 }),
	Sequence: varchar({ length: 255 }),
	Drawing: varchar({ length: 255 }),
	SheetNumber: varchar({ length: 255 }),
	DrawingRev: varchar({ length: 255 }),
	Description: varchar({ length: 255 }),
	WorkDiscipline: varchar({ length: 255 }),
	ScheduleResource: varchar({ length: 255 }),
	ClientMaterialSpec: varchar({ length: 255 }),
	PerformanceMaterialSpec: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerTAR_idx").on(table.JobID),
	index("UID-Landing_TrackerTAR_idx").on(table.UID),
]);

export const Prog_FAREV = mysqlTable("Prog_FAREV", {
	ID: int({ unsigned: true }).autoincrement().primaryKey(),
	GUID: binary({ length: 16 }),
	RecordNumber: mediumint({ unsigned: true }),
	JobID: smallint(),
	DisciplineID: tinyint(),
	QueID: tinyint(),
	SubmissionGUID: binary({ length: 16 }),
	TrackerID: mediumint({ unsigned: true }),
	StatusID: tinyint(),
	Quantity: decimal({ mode: 'string', unsigned: true, precision: 8, scale: 2 }),
	Percent: decimal({ mode: 'string', precision: 3, scale: 2 }),
	EarnedValue: decimal({ mode: 'string', unsigned: true, precision: 7, scale: 6 }),
	Locked: mediumint({ unsigned: true }),
	ROCID: smallint({ unsigned: true }),
	ClaimedTime: timestamp({ mode: 'string' }),
	ShiftDate: date({ mode: 'string' }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
});

export const Prog_TrackerMetaREV = mysqlTable("Prog_TrackerMetaREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	JobID: smallint({ unsigned: true }),
	DisciplineID: tinyint(),
	UID: mediumint({ unsigned: true }),
	BidID: mediumint({ unsigned: true }),
	ClientID: varchar({ length: 100 }),
	ProjectServicesRep: varchar({ length: 6 }),
	Transmittal: varchar({ length: 45 }),
	Scope: varchar({ length: 45 }),
	Phase: varchar({ length: 45 }),
	Stage: varchar({ length: 45 }),
	Priority: varchar({ length: 45 }),
	TestPackage: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 45 }),
	P6ID: varchar({ length: 45 }),
	P6Description: varchar({ length: 255 }),
	ContractorID: smallint({ unsigned: true }),
	System: varchar({ length: 45 }),
	Service: varchar({ length: 45 }),
	Area: varchar({ length: 45 }),
	Location: varchar({ length: 45 }),
	Structure: varchar({ length: 45 }),
	CU: varchar({ length: 45 }),
	Elevation: varchar({ length: 45 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
	TakeOffQuantity: decimal({ mode: 'string', precision: 12, scale: 2 }),
	QuantityUnit: varchar({ length: 45 }),
	EstimatedHours: decimal({ mode: 'string', precision: 16, scale: 6 }),
	ActivityTypeID: smallint({ unsigned: true }),
	ROCSetID: smallint({ unsigned: true }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerMetaREV").on(table.OrgID),
]);

export const Prog_ROCSetREV = mysqlTable("Prog_ROCSetREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: smallint({ unsigned: true }),
	JobID: smallint({ unsigned: true }),
	ActivityTypeID: smallint({ unsigned: true }),
	Label: varchar({ length: 255 }),
	MatchColumn: varchar({ length: 45 }),
	MatchValue: varchar({ length: 255 }),
	isDefault: tinyint(),
	isStandardEdit: tinyint(),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_ROCSetREV").on(table.OrgID),
]);

export const Prog_FA = mysqlTable("Prog_FA", {
	GUID: binary({ length: 16 }).default(sql`uuid_to_bin(uuid())`).primaryKey(),
	RecordNumber: mediumint({ unsigned: true }).autoincrement().notNull(),
	JobID: smallint({ unsigned: true }).notNull().references(() => Jobs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	DisciplineID: tinyint().notNull().references(() => Ref_Disciplines.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	QueID: tinyint().default(0).notNull().references(() => Ref_Prog_Ques.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	SubmissionGUID: binary({ length: 16 }).notNull().references(() => Prog_SubmissionDetails.GUID, { onDelete: "cascade", onUpdate: "cascade" } ),
	TrackerID: mediumint({ unsigned: true }).references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	StatusID: tinyint().default(0).notNull().references(() => Ref_Prog_ActivityStatuses.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Quantity: decimal({ mode: 'string', unsigned: true, precision: 8, scale: 2 }),
	Percent: decimal({ mode: 'string', precision: 3, scale: 2 }),
	EarnedValue: decimal({ mode: 'string', unsigned: true, precision: 7, scale: 6 }),
	Locked: mediumint({ unsigned: true }).references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	ROCID: mediumint({ unsigned: true }).notNull().references(() => Prog_ROCs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	ClaimedTime: timestamp({ mode: 'string' }),
	ShiftDate: date({ mode: 'string' }),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-Discipline/Que/TrackerID/Date/EV-Prog_FA").on(table.DisciplineID, table.QueID, table.TrackerID, table.ShiftDate, table.EarnedValue),
	index("Combo-TrackerID/QueID/FATypeID-Prog_FA").on(table.TrackerID, table.QueID),
	index("DisciplineID-Prog_FA_idx").on(table.DisciplineID),
	index("JobID-Prog_FA_idx").on(table.JobID),
	index("Locked_Prog_FA_idx").on(table.Locked),
	index("ModifiedBy-Prog_FA_idx").on(table.ModifiedBy),
	index("QueID-Prog_FA_idx").on(table.QueID),
	uniqueIndex("RecordNumber_UNIQUE").on(table.RecordNumber),
	index("StatusID-Prog_FA_idx").on(table.StatusID),
	index("SubmissionGUID-Prog_FA_idx").on(table.SubmissionGUID),
]);

export const Prog_ROCsREV = mysqlTable("Prog_ROCsREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	ROCSetID: smallint({ unsigned: true }),
	Seq: smallint({ unsigned: true }),
	Label: varchar({ length: 255 }),
	LabelShort: varchar({ length: 45 }),
	Percent: decimal({ mode: 'string', precision: 7, scale: 6 }),
	InputMethod: varchar({ length: 3 }),
	InputQuantityRound: tinyint({ unsigned: true }),
	InputClaimBehaviorSpool: varchar({ length: 45 }),
	InputClaimBehaviorISOQuantity: varchar({ length: 45 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_ROCsREV").on(table.OrgID),
]);

export const Prog_ROCs = mysqlTable("Prog_ROCs", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	ROCSetID: smallint({ unsigned: true }).notNull().references(() => Prog_ROCSet.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	Seq: smallint({ unsigned: true }).default(1).notNull(),
	Label: varchar({ length: 255 }).notNull(),
	LabelShort: varchar({ length: 45 }).notNull(),
	Percent: decimal({ mode: 'string', precision: 7, scale: 6 }).notNull(),
	InputMethod: varchar({ length: 3 }).notNull(),
	InputQuantityRound: tinyint({ unsigned: true }).notNull(),
	InputClaimBehaviorSpool: varchar({ length: 45 }).notNull(),
	InputClaimBehaviorISOQuantity: varchar({ length: 45 }).notNull(),
	ModifiedBy: mediumint({ unsigned: true }).references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	uniqueIndex("Combo-ROCSetID/Seq-Prog_ROCs").on(table.ROCSetID, table.Seq),
	index("Label-Prog_ROCs_idx").on(table.Label),
	index("LabelShort-Prog_ROCs_idx").on(table.LabelShort),
	index("ModifiedBy-Prog_ROCs_idx").on(table.ModifiedBy),
	index("ROCSetID-Prog_ROCs_idx").on(table.ROCSetID),
	check("InputMethod-Prog_ROCs-CheckConstraint", sql`(\`InputMethod\` in (_utf8mb4\'Q\',_utf8mb4\'P\',_utf8mb4\'QP\'))`),
]);

export const Prog_ROCSet = mysqlTable("Prog_ROCSet", {
	ID: smallint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).notNull().references(() => Jobs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ActivityTypeID: smallint({ unsigned: true }).notNull().references(() => Ref_Prog_ActivityTypes.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	Label: varchar({ length: 255 }).notNull(),
	MatchColumn: varchar({ length: 45 }),
	MatchValue: varchar({ length: 255 }),
	isDefault: tinyint().default(0).notNull(),
	isStandardEdit: tinyint().default(0).notNull(),
	ModifiedBy: mediumint({ unsigned: true }).references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ActivityTypeID-Prog_ROCSet_idx").on(table.ActivityTypeID),
	index("Combo-Default/Standard-Prog_ROCSet.idx").on(table.isDefault, table.isStandardEdit),
	uniqueIndex("Combo-Job/ATID/Label/MatchColumn/MatchValue-Prog_ROCSet").on(table.JobID, table.ActivityTypeID, table.Label, table.MatchColumn, table.MatchValue),
	index("JobID-Prog_ROCSet_idx").on(table.JobID),
	index("ModifiedBy-Prog_ROCSet_idx").on(table.ModifiedBy),
]);

export const Prog_BAComments = mysqlTable("Prog_BAComments", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	ActivityGUID: binary({ length: 16 }).notNull().references(() => Prog_BA.GUID, { onDelete: "cascade", onUpdate: "cascade" } ),
	Comment: varchar({ length: 1024 }).notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ActivityGUID-Prog_BAComments_idx").on(table.ActivityGUID),
	index("ModifiedBy-Prog_BAComments_idx").on(table.ModifiedBy),
]);

export const Prog_FAMeta = mysqlTable("Prog_FAMeta", {
	ActivityGUID: binary({ length: 16 }).default(sql`uuid_to_bin(uuid())`).primaryKey().references(() => Prog_FA.GUID, { onDelete: "cascade", onUpdate: "cascade" } ),
	FieldNote: varchar({ length: 1024 }),
	TimeInForm: smallint().default(1).notNull(),
	BAGUID: binary({ length: 16 }).references(() => Prog_BA.GUID, { onUpdate: "cascade" } ),
	RejectID: tinyint(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ModifiedBy-Prog_FAMeta_idx").on(table.ModifiedBy),
	index("RejectID-Prog_FAMeta_idx").on(table.RejectID),
]);

export const Prog_FAPaintWelds = mysqlTable("Prog_FAPaintWelds", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	ActivityGUID: binary({ length: 16 }).notNull().references(() => Prog_FA.GUID, { onDelete: "cascade", onUpdate: "cascade" } ),
	WeldNumber: varchar({ length: 45 }).notNull(),
	WeldSpool1: varchar({ length: 45 }),
	WeldSpool2: varchar({ length: 45 }),
	WeldDrawingNumber: varchar({ length: 45 }),
	WeldLineNumber: varchar({ length: 45 }),
	WeldSheetNumber: varchar({ length: 3 }),
	WeldPaintSpec: varchar({ length: 45 }),
	WeldSize: decimal({ mode: 'string', precision: 5, scale: 2 }),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ActivityGUID-Prog_FAPaintWelds_idx").on(table.ActivityGUID),
	index("ModifiedBy-Prog_FAPaintWelds_idx").on(table.ModifiedBy),
]);

export const Prog_TrackerMeta = mysqlTable("Prog_TrackerMeta", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).notNull().references(() => Jobs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	DisciplineID: tinyint().notNull().references(() => Ref_Disciplines.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	UID: mediumint({ unsigned: true }).notNull(),
	BidID: mediumint({ unsigned: true }).notNull(),
	ClientID: varchar({ length: 100 }).default("0").notNull(),
	ProjectServicesRep: varchar({ length: 6 }).default("0").notNull(),
	Transmittal: varchar({ length: 45 }).default("0").notNull(),
	Scope: varchar({ length: 45 }).default("0").notNull(),
	Phase: varchar({ length: 45 }).default("0").notNull(),
	Stage: varchar({ length: 45 }).default("0").notNull(),
	Priority: varchar({ length: 45 }).default("0").notNull(),
	TestPackage: varchar({ length: 255 }).default("0").notNull(),
	ConstructionWorkPackage: varchar({ length: 255 }).default("0").notNull(),
	InstallationWorkPackage: varchar({ length: 255 }).default("0").notNull(),
	CostCode: varchar({ length: 45 }).default("0").notNull(),
	P6ID: varchar({ length: 45 }).default("0").notNull(),
	P6Description: varchar({ length: 255 }).default("0").notNull(),
	ContractorID: smallint({ unsigned: true }).default(1).notNull().references(() => Contractors.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	System: varchar({ length: 45 }).default("0").notNull(),
	Service: varchar({ length: 45 }).default("0").notNull(),
	Area: varchar({ length: 45 }).default("0").notNull(),
	Location: varchar({ length: 45 }).default("0").notNull(),
	Structure: varchar({ length: 45 }).default("0").notNull(),
	CU: varchar({ length: 45 }).default("0").notNull(),
	Elevation: varchar({ length: 45 }).default("0").notNull(),
	FilterGroup1: varchar({ length: 255 }).default("0").notNull(),
	FilterGroup2: varchar({ length: 255 }).default("0").notNull(),
	FilterGroup3: varchar({ length: 255 }).default("0").notNull(),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
	TakeOffQuantity: decimal({ mode: 'string', precision: 12, scale: 2 }).notNull(),
	QuantityUnit: varchar({ length: 45 }).notNull(),
	EstimatedHours: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),
	ActivityTypeID: smallint({ unsigned: true }).notNull().references(() => Ref_Prog_ActivityTypes.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	ROCSetID: smallint({ unsigned: true }).notNull().references(() => Prog_ROCSet.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ActivityTypeID-Prog_TrackerMeta_idx").on(table.ActivityTypeID),
	index("BidID-Prog_TrackerMeta").on(table.BidID),
	index("ClientID-Prog_TrackerMeta").on(table.ClientID),
	uniqueIndex("Combo-JobID/DisciplineID/UID-Prog_TrackerMeta").on(table.JobID, table.DisciplineID, table.UID),
	index("DisciplineID-Prog_TrackerMeta_idx").on(table.DisciplineID),
	index("ROCSetID-Prog_TrackerMeta_idx").on(table.ROCSetID),
	check("EstimatedHours-Prog_TrackerMeta", sql`(\`EstimatedHours\` > 0)`),
	check("TakeOffQuantity-Prog_TrackerMeta", sql`(\`TakeOffQuantity\` > 0)`),
]);

export const Landing_TrackerFireproof = mysqlTable("Landing_TrackerFireproof", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	ComponentNumber: varchar({ length: 255 }),
	Drawing: varchar({ length: 255 }),
	SheetNumber: varchar({ length: 255 }),
	DrawingRev: varchar({ length: 255 }),
	Description: varchar({ length: 255 }),
	CoatingType: varchar({ length: 255 }),
	ClientMaterialSpec: varchar({ length: 255 }),
	PerformanceMaterialSpec: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerFireproof_idx").on(table.JobID),
	index("UID-Landing_TrackerFireproof_idx").on(table.UID),
]);

export const Landing_TrackerPaint = mysqlTable("Landing_TrackerPaint", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	ComponentNumber: varchar({ length: 255 }),
	LineNumber: varchar({ length: 255 }),
	Drawing: varchar({ length: 255 }),
	SheetNumber: varchar({ length: 255 }),
	DrawingRev: varchar({ length: 255 }),
	Description: varchar({ length: 255 }),
	ClientMaterialSpec: varchar({ length: 255 }),
	PerformanceMaterialSpec: varchar({ length: 255 }),
	Size: varchar({ length: 255 }),
	CoatCount: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerPaint_idx").on(table.JobID),
	index("UID-Landing_TrackerPaint_idx").on(table.UID),
]);

export const Prog_TrackerSpecsFireproof = mysqlTable("Prog_TrackerSpecsFireproof", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ComponentNumber: varchar({ length: 100 }).default("0").notNull(),
	Drawing: varchar({ length: 100 }).default("0").notNull(),
	SheetNumber: varchar({ length: 3 }).default("0").notNull(),
	DrawingRev: varchar({ length: 100 }).default("0").notNull(),
	Description: varchar({ length: 255 }).default("0").notNull(),
	CoatingType: varchar({ length: 45 }).default("0").notNull(),
	ActivityType: varchar({ length: 45 }).default("0").notNull(),
	ActivitySubType: varchar({ length: 45 }).default("0").notNull(),
	ClientMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	PerformanceMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-AT/AST-Prog_TrackerSpecsFireproof").on(table.ActivityType, table.ActivitySubType),
]);

export const Prog_TrackerSpecsFireproofREV = mysqlTable("Prog_TrackerSpecsFireproofREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	ComponentNumber: varchar({ length: 100 }),
	Drawing: varchar({ length: 100 }),
	SheetNumber: varchar({ length: 3 }),
	DrawingRev: varchar({ length: 100 }),
	Description: varchar({ length: 255 }),
	CoatingType: varchar({ length: 45 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ClientMaterialSpec: varchar({ length: 45 }),
	PerformanceMaterialSpec: varchar({ length: 45 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsFireproofREV").on(table.OrgID),
]);

export const Prog_TrackerSpecsPaint = mysqlTable("Prog_TrackerSpecsPaint", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ComponentNumber: varchar({ length: 100 }),
	LineNumber: varchar({ length: 100 }).default("0").notNull(),
	Drawing: varchar({ length: 100 }).default("0").notNull(),
	SheetNumber: varchar({ length: 3 }).notNull(),
	DrawingRev: varchar({ length: 100 }).default("0").notNull(),
	Description: varchar({ length: 255 }).notNull(),
	ActivityType: varchar({ length: 45 }).notNull(),
	ActivitySubType: varchar({ length: 45 }).notNull(),
	ClientMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	PerformanceMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }).default('0.00').notNull(),
	CoatCount: tinyint({ unsigned: true }).default(1).notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("ActivityType-Prog_TrackerPaintSpecs").on(table.ActivityType),
]);

export const Prog_TrackerSpecsPaintREV = mysqlTable("Prog_TrackerSpecsPaintREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	ComponentNumber: varchar({ length: 100 }),
	LineNumber: varchar({ length: 100 }),
	Drawing: varchar({ length: 100 }),
	SheetNumber: varchar({ length: 3 }),
	DrawingRev: varchar({ length: 100 }),
	Description: varchar({ length: 255 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ClientMaterialSpec: varchar({ length: 45 }),
	PerformanceMaterialSpec: varchar({ length: 45 }),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }),
	CoatCount: tinyint({ unsigned: true }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsPaintREV").on(table.OrgID),
]);

export const Landing_TrackerSteel = mysqlTable("Landing_TrackerSteel", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	PieceMark: varchar({ length: 255 }),
	Sequence: varchar({ length: 255 }),
	Drawing: varchar({ length: 255 }),
	SheetNumber: varchar({ length: 255 }),
	DrawingRev: varchar({ length: 255 }),
	DetailDrawing: varchar({ length: 255 }),
	DetailRev: varchar({ length: 255 }),
	Description: varchar({ length: 255 }),
	ClientMaterialSpec: varchar({ length: 255 }),
	PerformanceMaterialSpec: varchar({ length: 255 }),
	MaterialType: varchar({ length: 255 }),
	WeightClass: varchar({ length: 255 }),
	Length: varchar({ length: 255 }),
	Tons: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerSteel_idx").on(table.JobID),
	index("UID-Landing_TrackerSteel_idx").on(table.UID),
]);

export const Landing_TrackerEquip = mysqlTable("Landing_TrackerEquip", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	ComponentNumber: varchar({ length: 255 }),
	Drawing: varchar({ length: 255 }),
	SheetNumber: varchar({ length: 255 }),
	DrawingRev: varchar({ length: 255 }),
	Description: varchar({ length: 255 }),
	EquipmentType: varchar({ length: 255 }),
	ClientMaterialSpec: varchar({ length: 255 }),
	PerformanceMaterialSpec: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerEquip_idx").on(table.JobID),
	index("UID-Landing_TrackerEquip_idx").on(table.UID),
]);

export const Prog_TrackerSpecsEquip = mysqlTable("Prog_TrackerSpecsEquip", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	ComponentNumber: varchar({ length: 100 }).default("0").notNull(),
	Drawing: varchar({ length: 100 }).notNull(),
	SheetNumber: varchar({ length: 3 }).notNull(),
	DrawingRev: varchar({ length: 100 }).default("0").notNull(),
	Description: varchar({ length: 255 }).notNull(),
	EquipmentType: varchar({ length: 45 }).notNull(),
	ActivityType: varchar({ length: 45 }).notNull(),
	ActivitySubType: varchar({ length: 45 }).default("0").notNull(),
	ClientMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	PerformanceMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-AT/AST-Prog_TrackerEquipSpecs").on(table.ActivityType, table.ActivitySubType),
]);

export const Prog_TrackerSpecsEquipREV = mysqlTable("Prog_TrackerSpecsEquipREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	ComponentNumber: varchar({ length: 100 }),
	Drawing: varchar({ length: 100 }),
	SheetNumber: varchar({ length: 3 }),
	DrawingRev: varchar({ length: 100 }),
	Description: varchar({ length: 255 }),
	EquipmentType: varchar({ length: 45 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ClientMaterialSpec: varchar({ length: 45 }),
	PerformanceMaterialSpec: varchar({ length: 45 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsEquipREV").on(table.OrgID),
]);

export const Prog_TrackerSpecsSteel = mysqlTable("Prog_TrackerSpecsSteel", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	PieceMark: varchar({ length: 100 }).default("0").notNull(),
	Sequence: varchar({ length: 100 }).default("0").notNull(),
	Drawing: varchar({ length: 100 }).notNull(),
	SheetNumber: varchar({ length: 3 }).notNull(),
	DrawingRev: varchar({ length: 100 }).default("0").notNull(),
	DetailDrawing: varchar({ length: 100 }).default("0").notNull(),
	DetailRev: varchar({ length: 100 }).default("0").notNull(),
	Description: varchar({ length: 255 }).notNull(),
	ActivityType: varchar({ length: 45 }).notNull(),
	ActivitySubType: varchar({ length: 45 }).default("0").notNull(),
	ClientMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	PerformanceMaterialSpec: varchar({ length: 45 }).default("0").notNull(),
	MaterialType: varchar({ length: 45 }).default("0").notNull(),
	WeightClass: varchar({ length: 45 }).default("0").notNull(),
	Length: decimal({ mode: 'string', precision: 10, scale: 2 }).default('0.00').notNull(),
	Tons: decimal({ mode: 'string', precision: 10, scale: 3 }).default('0.000').notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-AT/AST-Prog_TrackerSteelSpecs").on(table.ActivityType, table.ActivitySubType),
]);

export const Prog_TrackerSpecsSteelREV = mysqlTable("Prog_TrackerSpecsSteelREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	PieceMark: varchar({ length: 100 }),
	Sequence: varchar({ length: 100 }),
	Drawing: varchar({ length: 100 }),
	SheetNumber: varchar({ length: 3 }),
	DrawingRev: varchar({ length: 100 }),
	DetailDrawing: varchar({ length: 100 }),
	DetailRev: varchar({ length: 100 }),
	Description: varchar({ length: 255 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ClientMaterialSpec: varchar({ length: 45 }),
	PerformanceMaterialSpec: varchar({ length: 45 }),
	MaterialType: varchar({ length: 45 }),
	WeightClass: varchar({ length: 45 }),
	Length: decimal({ mode: 'string', precision: 10, scale: 2 }),
	Tons: decimal({ mode: 'string', precision: 10, scale: 3 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsSteelREV").on(table.OrgID),
]);

export const Prog_BA = mysqlTable("Prog_BA", {
	GUID: binary({ length: 16 }).default(sql`uuid_to_bin(uuid())`).primaryKey(),
	RecordNumber: mediumint({ unsigned: true }).autoincrement().notNull(),
	JobID: smallint({ unsigned: true }).notNull().references(() => Jobs.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	DisciplineID: tinyint().notNull().references(() => Ref_Disciplines.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	QueID: tinyint().default(0).notNull().references(() => Ref_Prog_Ques.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	SubmissionGUID: binary({ length: 16 }).notNull().references(() => Prog_SubmissionDetails.GUID, { onDelete: "cascade", onUpdate: "cascade" } ),
	MatchColumn: varchar({ length: 45 }),
	MatchValue: varchar({ length: 255 }),
	ROCLabelShort: varchar({ length: 45 }).notNull(),
	AdvancedClaimData: json(),
	StatusID: tinyint().default(0).notNull().references(() => Ref_Prog_ActivityStatuses.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Percent: decimal({ mode: 'string', precision: 3, scale: 2 }).default('0.00').notNull(),
	Notes: varchar({ length: 1024 }),
	ClaimRequester: varchar({ length: 255 }),
	TimeInForm: smallint().default(1).notNull(),
	ClaimedTime: timestamp({ mode: 'string' }),
	ShiftDate: date({ mode: 'string' }),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-Job/Discipline/Que/Date-Prog_BA").on(table.JobID, table.DisciplineID, table.QueID, table.ShiftDate),
	index("Combo-MatchColumn/MatchValue/ROCLabelShort-Prog_BA").on(table.MatchColumn, table.MatchValue, table.ROCLabelShort),
	index("Combo-MatchValue/QueID/JobID-Prog_BA").on(table.MatchValue, table.QueID, table.JobID),
	index("DisciplineID-Prog_BA_idx").on(table.DisciplineID),
	index("JobID-Prog_BA_idx").on(table.JobID),
	index("ModifiedBy-Prog_BA_idx").on(table.ModifiedBy),
	index("QueID-Prog_BA_idx").on(table.QueID),
	uniqueIndex("RecordNumber_UNIQUE").on(table.RecordNumber),
	index("StatusID-Prog_BA_idx").on(table.StatusID),
	index("SubmissionGUID-Prog_BA_idx").on(table.SubmissionGUID),
]);

export const Prog_BAREV = mysqlTable("Prog_BAREV", {
	ID: int({ unsigned: true }).autoincrement().primaryKey(),
	GUID: binary({ length: 16 }),
	RecordNumber: mediumint({ unsigned: true }),
	JobID: smallint({ unsigned: true }),
	DisciplineID: tinyint(),
	QueID: tinyint(),
	SubmissionGUID: binary({ length: 16 }),
	MatchColumn: varchar({ length: 45 }),
	MatchValue: varchar({ length: 255 }),
	ROCLabelShort: varchar({ length: 45 }),
	AdvancedClaimData: json(),
	StatusID: tinyint(),
	Percent: decimal({ mode: 'string', precision: 3, scale: 2 }),
	Notes: varchar({ length: 1024 }),
	ClaimRequester: varchar({ length: 255 }),
	TimeInForm: smallint(),
	ClaimedTime: timestamp({ mode: 'string' }),
	ShiftDate: date({ mode: 'string' }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("GUID-Prog_BAREV").on(table.GUID),
]);

export const Landing_TrackerTraceElect = mysqlTable("Landing_TrackerTraceElect", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	JobID: smallint({ unsigned: true }).references(() => Jobs.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	RowNumber: mediumint({ unsigned: true }),
	UID: varchar({ length: 255 }),
	BidID: varchar({ length: 255 }),
	ClientID: varchar({ length: 255 }),
	ProjectServicesRep: varchar({ length: 255 }),
	Transmittal: varchar({ length: 255 }),
	Scope: varchar({ length: 255 }),
	Phase: varchar({ length: 255 }),
	Stage: varchar({ length: 255 }),
	Priority: varchar({ length: 255 }),
	TestPackageNumber: varchar({ length: 255 }),
	ConstructionWorkPackage: varchar({ length: 255 }),
	InstallationWorkPackage: varchar({ length: 255 }),
	CostCode: varchar({ length: 255 }),
	P6ID: varchar({ length: 255 }),
	P6Description: varchar({ length: 255 }),
	Contractor: varchar({ length: 255 }),
	System: varchar({ length: 255 }),
	Service: varchar({ length: 255 }),
	Area: varchar({ length: 255 }),
	Location: varchar({ length: 255 }),
	Structure: varchar({ length: 255 }),
	CU: varchar({ length: 255 }),
	Elevation: varchar({ length: 255 }),
	TraceTag: varchar({ length: 255 }),
	Panel: varchar({ length: 255 }),
	From: varchar({ length: 255 }),
	PanelDescription: varchar({ length: 255 }),
	FromDescription: varchar({ length: 255 }),
	ComponentDescription: varchar({ length: 255 }),
	WorkDiscipline: varchar({ length: 255 }),
	TypeSpec: varchar({ length: 255 }),
	PipeLine: varchar({ length: 255 }),
	PipeISO: varchar({ length: 255 }),
	Reel: varchar({ length: 255 }),
	ActivityClass: varchar({ length: 255 }),
	Sequence: varchar({ length: 255 }),
	Size: varchar({ length: 255 }),
	PipeFootage: varchar({ length: 255 }),
	TakeOffQuantity: varchar({ length: 255 }),
	QuantityUnit: varchar({ length: 255 }),
	EstimatedHours: varchar({ length: 255 }),
	ActivityType: varchar({ length: 255 }),
	ActivitySubType: varchar({ length: 255 }),
	FilterGroup1: varchar({ length: 255 }),
	FilterGroup2: varchar({ length: 255 }),
	FilterGroup3: varchar({ length: 255 }),
	WBS1: varchar({ length: 255 }),
	WBS2: varchar({ length: 255 }),
	WBS3: varchar({ length: 255 }),
	WBS4: varchar({ length: 255 }),
	WBS5: varchar({ length: 255 }),
	WBS6: varchar({ length: 255 }),
	WBS7: varchar({ length: 255 }),
	WBS8: varchar({ length: 255 }),
	WBS9: varchar({ length: 255 }),
	WBS10: varchar({ length: 255 }),
},
(table) => [
	index("JobID-Landing_TrackerTraceElect_idx").on(table.JobID),
	index("UID-Landing_TrackerTraceElect_idx").on(table.UID),
]);

export const Prog_TrackerSpecsTraceElect = mysqlTable("Prog_TrackerSpecsTraceElect", {
	ID: mediumint({ unsigned: true }).primaryKey().references(() => Prog_TrackerMeta.ID, { onDelete: "cascade", onUpdate: "cascade" } ),
	TraceTag: varchar({ length: 100 }).default("0").notNull(),
	Panel: varchar({ length: 100 }).default("0").notNull(),
	From: varchar({ length: 100 }).default("0").notNull(),
	PanelDescription: varchar({ length: 100 }).default("0").notNull(),
	FromDescription: varchar({ length: 100 }).default("0").notNull(),
	ComponentDescription: varchar({ length: 100 }).default("0").notNull(),
	WorkDiscipline: varchar({ length: 45 }).default("0").notNull(),
	TypeSpec: varchar({ length: 45 }).default("0").notNull(),
	PipeLine: varchar({ length: 100 }).default("0").notNull(),
	PipeISO: varchar({ length: 100 }).default("0").notNull(),
	Reel: varchar({ length: 45 }).default("0").notNull(),
	ActivityType: varchar({ length: 45 }).notNull(),
	ActivitySubType: varchar({ length: 45 }).notNull(),
	ActivityClass: varchar({ length: 45 }).default("0").notNull(),
	Sequence: smallint({ unsigned: true }).default(0).notNull(),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }).default('0.00').notNull(),
	PipeFootage: decimal({ mode: 'string', precision: 12, scale: 2 }).default('0.00').notNull(),
	ModifiedBy: mediumint({ unsigned: true }).notNull().references(() => Users.ID, { onDelete: "restrict", onUpdate: "cascade" } ),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }).defaultNow(),
},
(table) => [
	index("Combo-AT/AST-Prog_TrackerSpecsTraceElect").on(table.ActivityType, table.ActivitySubType),
]);

export const Prog_TrackerSpecsTraceElectREV = mysqlTable("Prog_TrackerSpecsTraceElectREV", {
	ID: mediumint({ unsigned: true }).autoincrement().primaryKey(),
	OrgID: mediumint({ unsigned: true }),
	TraceTag: varchar({ length: 100 }),
	Panel: varchar({ length: 100 }),
	From: varchar({ length: 100 }),
	PanelDescription: varchar({ length: 100 }),
	FromDescription: varchar({ length: 100 }),
	ComponentDescription: varchar({ length: 100 }),
	WorkDiscipline: varchar({ length: 45 }),
	TypeSpec: varchar({ length: 45 }),
	PipeLine: varchar({ length: 100 }),
	PipeISO: varchar({ length: 100 }),
	Reel: varchar({ length: 45 }),
	ActivityType: varchar({ length: 45 }),
	ActivitySubType: varchar({ length: 45 }),
	ActivityClass: varchar({ length: 45 }),
	Sequence: smallint({ unsigned: true }),
	Size: decimal({ mode: 'string', precision: 5, scale: 2 }),
	PipeFootage: decimal({ mode: 'string', precision: 12, scale: 2 }),
	ModifiedBy: mediumint({ unsigned: true }),
	Rev: smallint(),
	TimeStamp: timestamp({ mode: 'string' }),
},
(table) => [
	index("OrgID-Prog_TrackerSpecsTraceElectREV").on(table.OrgID),
]);

export const Prog_FASAEarnedALL_View = mysqlTable("Prog_FASAEarnedALL_View", {


TrackerID: mediumint({ unsigned: true }),

JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalled: decimal({ mode: 'string', precision: 65, scale: 24 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }),
});

export const Prog_FASAEarnedCivil_View = mysqlTable("Prog_FASAEarnedCivil_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalled: decimal({ mode: 'string', precision: 19, scale: 8 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 30, scale: 18 }),
});

export const Prog_FASAEarnedElectCable_View = mysqlTable("Prog_FASAEarnedElectCable_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalledPull: decimal({ mode: 'string', precision: 19, scale: 8 }),

QuantityInstalledTail_F: decimal({ mode: 'string', precision: 19, scale: 8 }),

QuantityInstalledTail_T: decimal({ mode: 'string', precision: 19, scale: 8 }),

QuantityInstalledGland_F: decimal({ mode: 'string', precision: 19, scale: 8 }),

QuantityInstalledGland_T: decimal({ mode: 'string', precision: 19, scale: 8 }),

QuantityInstalledTerm_F: decimal({ mode: 'string', precision: 19, scale: 8 }),

QuantityInstalledTerm_T: decimal({ mode: 'string', precision: 19, scale: 8 }),

QuantityInstalledTesting: decimal({ mode: 'string', precision: 19, scale: 8 }),

HoursEarnedPull: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedTail_F: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedTail_T: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedGland_F: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedGland_T: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedTerm_F: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedTerm_T: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedTesting: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 30, scale: 18 }),
});

export const Prog_FASAEarnedElectConduit_View = mysqlTable("Prog_FASAEarnedElectConduit_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalled: decimal({ mode: 'string', precision: 19, scale: 8 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 30, scale: 18 }),
});

export const Prog_FASAEarnedElectGeneral_View = mysqlTable("Prog_FASAEarnedElectGeneral_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalled: decimal({ mode: 'string', precision: 19, scale: 8 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 30, scale: 18 }),
});

export const Prog_FASAEarnedElectInst_View = mysqlTable("Prog_FASAEarnedElectInst_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalled: decimal({ mode: 'string', precision: 19, scale: 8 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 30, scale: 18 }),
});

export const Prog_FASAEarnedElectTrace_View = mysqlTable("Prog_FASAEarnedElectTrace_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalled: decimal({ mode: 'string', precision: 19, scale: 8 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 30, scale: 18 }),
});

export const Prog_FASAEarnedElectTray_View = mysqlTable("Prog_FASAEarnedElectTray_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalled: decimal({ mode: 'string', precision: 19, scale: 8 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 30, scale: 18 }),
});

export const Prog_FASAEarnedEquip_View = mysqlTable("Prog_FASAEarnedEquip_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalled: decimal({ mode: 'string', precision: 19, scale: 8 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 30, scale: 18 }),
});

export const Prog_FASAEarnedFireproof_View = mysqlTable("Prog_FASAEarnedFireproof_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalledPrep: decimal({ mode: 'string', precision: 19, scale: 8 }),

QuantityInstalledPrime: decimal({ mode: 'string', precision: 19, scale: 8 }),

QuantityInstalledUnder: decimal({ mode: 'string', precision: 23, scale: 12 }),

QuantityInstalledFinish: decimal({ mode: 'string', precision: 19, scale: 8 }),

QuantityInstalledSellPunch: decimal({ mode: 'string', precision: 19, scale: 8 }),

QuantityInstalledMisc: decimal({ mode: 'string', precision: 19, scale: 8 }),

HoursEarnedPrep: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedPrime: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedUnder: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedFinish: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedSellPunch: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedMisc: decimal({ mode: 'string', precision: 30, scale: 18 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 30, scale: 18 }),
});

export const Prog_FASAEarnedInsulation_View = mysqlTable("Prog_FASAEarnedInsulation_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalled: decimal({ mode: 'string', precision: 19, scale: 8 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 30, scale: 18 }),
});

export const Prog_FASAEarnedPaint_View = mysqlTable("Prog_FASAEarnedPaint_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalledPrep: decimal({ mode: 'string', precision: 41, scale: 8 }),

QuantityInstalledPrime: decimal({ mode: 'string', precision: 41, scale: 8 }),

QuantityInstalledUnder: decimal({ mode: 'string', precision: 45, scale: 12 }),

QuantityInstalledTop: decimal({ mode: 'string', precision: 41, scale: 8 }),

QuantityInstalledSellPunch: decimal({ mode: 'string', precision: 41, scale: 8 }),

QuantityInstalledTouchUp: decimal({ mode: 'string', precision: 41, scale: 8 }),

QuantityInstalledMisc: decimal({ mode: 'string', precision: 41, scale: 8 }),

HoursEarnedPrep: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedPrime: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedUnder: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedTop: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedSellPunch: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedTouchUp: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedMisc: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }),
});

export const Prog_FASAEarnedPipe_View = mysqlTable("Prog_FASAEarnedPipe_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalled: decimal({ mode: 'string', precision: 41, scale: 8 }),

EarnedValueFootage: int().notNull(),

HoursEarnedMech: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedSellPunch: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedRFT: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedHydro: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedCTO: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }),
});

export const Prog_FASAEarnedSteel_View = mysqlTable("Prog_FASAEarnedSteel_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalledShake: decimal({ mode: 'string', precision: 41, scale: 8 }),

QuantityInstalledErect: decimal({ mode: 'string', precision: 41, scale: 8 }),

QuantityInstalledBoltout: decimal({ mode: 'string', precision: 41, scale: 8 }),

QuantityInstalledImp: decimal({ mode: 'string', precision: 41, scale: 8 }),

QuantityInstalledSellPunch: decimal({ mode: 'string', precision: 41, scale: 8 }),

QuantityInstalledWeld: decimal({ mode: 'string', precision: 41, scale: 8 }),

QuantityInstalledDemo: decimal({ mode: 'string', precision: 41, scale: 8 }),

QuantityInstalledMisc: decimal({ mode: 'string', precision: 41, scale: 8 }),

EarnedValueTonnage: decimal({ mode: 'string', precision: 65, scale: 25 }),

HoursEarnedShake: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedErect: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedBoltout: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedImp: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedSellPunch: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedWeld: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedDemo: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedMisc: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }),
});

export const Prog_FASAEarnedTAR_View = mysqlTable("Prog_FASAEarnedTAR_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalled: decimal({ mode: 'string', precision: 41, scale: 8 }),

HoursEarnedMech: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedSellPunch: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedRFT: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedHydro: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedCTO: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }),
});

export const Prog_FASAEarnedTraceElect_View = mysqlTable("Prog_FASAEarnedTraceElect_View", {


JobID: smallint({ unsigned: true }).notNull(),

EarnedDate: date({ mode: 'string' }),

EarnedDateWeekEnding: date({ mode: 'string' }),

TrackerID: mediumint({ unsigned: true }),

TeamID: int({ unsigned: true }),

TeamNumber: int({ unsigned: true }),

Shift: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

QuantityInstalled: decimal({ mode: 'string', precision: 19, scale: 8 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 30, scale: 18 }),
});

export const Prog_PF_View = mysqlTable("Prog_PF_View", {


ShiftDate: date({ mode: 'string' }),

CostCode: varchar({ length: 255 }),

PM: varchar({ length: 250 }),

CM: varchar({ length: 250 }),

SM: varchar({ length: 250 }),

AM: varchar({ length: 250 }),

Super: varchar({ length: 250 }),

GF: varchar({ length: 250 }),

Foreman: varchar({ length: 250 }),

Shift: varchar({ length: 255 }),

TeamNumber: int({ unsigned: true }),

SpentDirect1D: decimal({ mode: 'string', precision: 58, scale: 8 }),

SpentDirect3D: decimal({ mode: 'string', precision: 65, scale: 8 }),

SpentDirect7D: decimal({ mode: 'string', precision: 65, scale: 8 }),

SpentDirect14D: decimal({ mode: 'string', precision: 65, scale: 8 }),

SpentDirectJTD: decimal({ mode: 'string', precision: 65, scale: 8 }),

SpentIndirect1D: decimal({ mode: 'string', precision: 58, scale: 8 }),

SpentIndirect3D: decimal({ mode: 'string', precision: 65, scale: 8 }),

SpentIndirect7D: decimal({ mode: 'string', precision: 65, scale: 8 }),

SpentIndirect14D: decimal({ mode: 'string', precision: 65, scale: 8 }),

SpentIndirectJTD: decimal({ mode: 'string', precision: 65, scale: 8 }),

EWO1D: decimal({ mode: 'string', precision: 58, scale: 8 }),

EWO3D: decimal({ mode: 'string', precision: 65, scale: 8 }),

EWO7D: decimal({ mode: 'string', precision: 65, scale: 8 }),

EWO14D: decimal({ mode: 'string', precision: 65, scale: 8 }),

EWOJTD: decimal({ mode: 'string', precision: 65, scale: 8 }),

Earned1D: decimal({ mode: 'string', precision: 52, scale: 18 }),

Earned3D: decimal({ mode: 'string', precision: 65, scale: 18 }),

Earned7D: decimal({ mode: 'string', precision: 65, scale: 18 }),

Earned14D: decimal({ mode: 'string', precision: 65, scale: 18 }),

EarnedJTD: decimal({ mode: 'string', precision: 65, scale: 18 }),
});

export const Prog_TrackerCalcsALL_View = mysqlTable("Prog_TrackerCalcsALL_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalled: decimal({ mode: 'string', precision: 65, scale: 24 }).notNull(),

QuantityRemaining: decimal({ mode: 'string', precision: 65, scale: 24 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 56, scale: 18 }),

HoursRemainingAll: decimal({ mode: 'string', precision: 57, scale: 18 }),

PercentCompleteAll: decimal({ mode: 'string', precision: 65, scale: 22 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),
});

export const Prog_TrackerCalcsCivil_View = mysqlTable("Prog_TrackerCalcsCivil_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalled: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityRemaining: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursRemainingAll: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsElectCable_View = mysqlTable("Prog_TrackerCalcsElectCable_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityPull: decimal({ mode: 'string', precision: 12, scale: 2 }).notNull(),

QuantityTail_F: decimal({ mode: 'string', precision: 12, scale: 2 }).notNull(),

QuantityTail_T: decimal({ mode: 'string', precision: 12, scale: 2 }).notNull(),

QuantityGland_F: decimal({ mode: 'string', precision: 12, scale: 2 }).notNull(),

QuantityGland_T: decimal({ mode: 'string', precision: 12, scale: 2 }).notNull(),

QuantityTerm_F: decimal({ mode: 'string', precision: 12, scale: 2 }).notNull(),

QuantityTerm_T: decimal({ mode: 'string', precision: 12, scale: 2 }).notNull(),

QuantityTesting: decimal({ mode: 'string', precision: 12, scale: 2 }).notNull(),

QuantityInstalledPull: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityInstalledTail_F: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityInstalledTail_T: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityInstalledGland_F: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityInstalledGland_T: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityInstalledTerm_F: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityInstalledTerm_T: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityInstalledTesting: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityRemainingPull: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

QuantityRemainingTail_F: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

QuantityRemainingTail_T: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

QuantityRemainingGland_F: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

QuantityRemainingGland_T: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

QuantityRemainingTerm_F: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

QuantityRemainingTerm_T: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

QuantityRemainingTesting: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

HoursPull: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursTail_F: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursTail_T: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursGland_F: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursGland_T: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursTerm_F: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursTerm_T: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursTesting: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedPull: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedTail_F: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedTail_T: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedGland_F: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedGland_T: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedTerm_F: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedTerm_T: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedTesting: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursRemainingPull: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingTail_F: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingTail_T: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingGland_F: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingGland_T: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingTerm_F: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingTerm_T: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingTesting: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingAll: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

PercentCompletePull: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteTail_F: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteTail_T: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteGland_F: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteGland_T: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteTerm_F: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteTerm_T: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteTesting: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

DatePull: date({ mode: 'string' }),

DateTail_F: date({ mode: 'string' }),

DateTail_T: date({ mode: 'string' }),

DateGland_F: date({ mode: 'string' }),

DateGland_T: date({ mode: 'string' }),

DateTerm_F: date({ mode: 'string' }),

DateTerm_T: date({ mode: 'string' }),

DateTesting: date({ mode: 'string' }),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsElectConduit_View = mysqlTable("Prog_TrackerCalcsElectConduit_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalled: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityRemaining: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursRemainingAll: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsElectGeneral_View = mysqlTable("Prog_TrackerCalcsElectGeneral_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalled: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityRemaining: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursRemainingAll: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsElectInst_View = mysqlTable("Prog_TrackerCalcsElectInst_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalled: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityRemaining: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursRemainingAll: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsElectTrace_View = mysqlTable("Prog_TrackerCalcsElectTrace_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalled: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityRemaining: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursRemainingAll: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsElectTray_View = mysqlTable("Prog_TrackerCalcsElectTray_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalled: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityRemaining: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursRemainingAll: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsEquip_View = mysqlTable("Prog_TrackerCalcsEquip_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalled: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityRemaining: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursRemainingAll: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsFireproof_View = mysqlTable("Prog_TrackerCalcsFireproof_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalledPrep: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityInstalledPrime: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityInstalledUnder: decimal({ mode: 'string', precision: 45, scale: 12 }),

QuantityInstalledFinish: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityInstalledSellPunch: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityInstalledMisc: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityRemainingPrep: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityRemainingPrime: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityRemainingUnder: decimal({ mode: 'string', precision: 46, scale: 12 }),

QuantityRemainingFinish: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityRemainingSellPunch: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityRemainingMisc: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

HoursPrep: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursPrime: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursUnder: decimal({ mode: 'string', precision: 45, scale: 12 }),

HoursFinish: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursSellPunch: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursMisc: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedPrep: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedPrime: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedUnder: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedFinish: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedSellPunch: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedMisc: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 56, scale: 18 }),

HoursRemainingPrep: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingPrime: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingUnder: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingFinish: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingSellPunch: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingMisc: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingAll: decimal({ mode: 'string', precision: 57, scale: 18 }),

PercentCompletePrep: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompletePrime: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompleteUnder: decimal({ mode: 'string', precision: 36, scale: 10 }),

PercentCompleteFinish: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompleteSellPunch: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompleteMisc: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 65, scale: 22 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

DateFirstSell: date({ mode: 'string' }),

DateLastSell: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsInsulation_View = mysqlTable("Prog_TrackerCalcsInsulation_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalled: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityRemaining: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 45, scale: 12 }).notNull(),

HoursRemainingAll: decimal({ mode: 'string', precision: 46, scale: 12 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsPaint_View = mysqlTable("Prog_TrackerCalcsPaint_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalledPrep: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityInstalledPrime: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityInstalledUnder: decimal({ mode: 'string', precision: 45, scale: 12 }),

QuantityInstalledTop: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityInstalledSellPunch: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityInstalledTouchUp: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityInstalledMisc: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityRemainingPrep: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityRemainingPrime: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityRemainingUnder: decimal({ mode: 'string', precision: 46, scale: 12 }),

QuantityRemainingTop: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityRemainingSellPunch: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityRemainingTouchUp: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

QuantityRemainingMisc: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

HoursPrep: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursPrime: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursUnder: decimal({ mode: 'string', precision: 45, scale: 12 }),

HoursTop: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursSellPunch: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursTouchUp: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursMisc: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedPrep: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedPrime: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedUnder: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedTop: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedSellPunch: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedTouchUp: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedMisc: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 56, scale: 18 }),

HoursRemainingPrep: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingPrime: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingUnder: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingTop: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingSellPunch: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingTouchUp: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingMisc: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingAll: decimal({ mode: 'string', precision: 57, scale: 18 }),

PercentCompletePrep: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompletePrime: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompleteUnder: decimal({ mode: 'string', precision: 36, scale: 10 }),

PercentCompleteTop: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompleteSellPunch: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompleteTouchUp: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteMisc: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 65, scale: 22 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

DateFirstSell: date({ mode: 'string' }),

DateLastSell: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsPipe_View = mysqlTable("Prog_TrackerCalcsPipe_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalled: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityRemaining: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityOverrun: decimal({ mode: 'string', precision: 38, scale: 4 }).notNull(),

EarnedValueFootage: int().notNull(),

HoursMech: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursSellPunch: decimal({ mode: 'string', precision: 25, scale: 12 }),

HoursRFT: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursHydro: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursCTO: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedMech: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedSellPunch: decimal({ mode: 'string', precision: 54, scale: 18 }),

HoursEarnedRFT: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedHydro: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedCTO: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 55, scale: 18 }),

HoursRemainingMech: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingSellPunch: decimal({ mode: 'string', precision: 55, scale: 18 }),

HoursRemainingRFT: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingHydro: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingCTO: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingAll: decimal({ mode: 'string', precision: 56, scale: 18 }),

PercentCompleteMech: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompleteSellPunch: decimal({ mode: 'string', precision: 65, scale: 22 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 65, scale: 22 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

DateFirstSell: date({ mode: 'string' }),

DateLastSell: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsSteel_View = mysqlTable("Prog_TrackerCalcsSteel_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalledShake: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityInstalledErect: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityInstalledBoltout: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityInstalledImp: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityInstalledSellPunch: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityInstalledWeld: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityInstalledDemo: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityInstalledMisc: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityRemainingShake: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityRemainingErect: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityRemainingBoltout: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityRemainingImp: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityRemainingSellPunch: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

QuantityRemainingWeld: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

QuantityRemainingDemo: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

QuantityRemainingMisc: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

EarnedValueTonnage: decimal({ mode: 'string', precision: 65, scale: 25 }).notNull(),

HoursShake: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursErect: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursBoltout: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursImp: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursSellPunch: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursWeld: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursDemo: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursMisc: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedShake: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedErect: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedBoltout: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedImp: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedSellPunch: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedWeld: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedDemo: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedMisc: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 56, scale: 18 }),

HoursRemainingShake: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingErect: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingBoltout: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingImp: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingSellPunch: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingWeld: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingDemo: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingMisc: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

HoursRemainingAll: decimal({ mode: 'string', precision: 57, scale: 18 }),

PercentCompleteShake: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompleteErect: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompleteBoltout: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompleteImp: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompleteSellPunch: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompleteWeld: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteDemo: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteMisc: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 65, scale: 22 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

DateFirstSell: date({ mode: 'string' }),

DateLastSell: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsTAR_View = mysqlTable("Prog_TrackerCalcsTAR_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalled: decimal({ mode: 'string', precision: 41, scale: 8 }).notNull(),

QuantityRemaining: decimal({ mode: 'string', precision: 42, scale: 8 }).notNull(),

HoursMech: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursSellPunch: decimal({ mode: 'string', precision: 25, scale: 12 }),

HoursRFT: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursHydro: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursCTO: decimal({ mode: 'string', precision: 23, scale: 12 }),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedMech: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedSellPunch: decimal({ mode: 'string', precision: 54, scale: 18 }),

HoursEarnedRFT: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedHydro: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedCTO: decimal({ mode: 'string', precision: 52, scale: 18 }),

HoursEarnedAll: decimal({ mode: 'string', precision: 55, scale: 18 }),

HoursRemainingMech: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingSellPunch: decimal({ mode: 'string', precision: 55, scale: 18 }),

HoursRemainingRFT: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingHydro: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingCTO: decimal({ mode: 'string', precision: 53, scale: 18 }),

HoursRemainingAll: decimal({ mode: 'string', precision: 56, scale: 18 }),

PercentCompleteMech: decimal({ mode: 'string', precision: 32, scale: 6 }).notNull(),

PercentCompleteSellPunch: decimal({ mode: 'string', precision: 65, scale: 22 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 65, scale: 22 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

DateFirstSell: date({ mode: 'string' }),

DateLastSell: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

export const Prog_TrackerCalcsTraceElect_View = mysqlTable("Prog_TrackerCalcsTraceElect_View", {


ID: mediumint({ unsigned: true }).notNull(),

QuantityInstalled: decimal({ mode: 'string', precision: 48, scale: 14 }).notNull(),

QuantityRemaining: decimal({ mode: 'string', precision: 49, scale: 14 }).notNull(),

HoursAll: decimal({ mode: 'string', precision: 16, scale: 6 }).notNull(),

HoursEarnedAll: decimal({ mode: 'string', precision: 52, scale: 18 }).notNull(),

HoursRemainingAll: decimal({ mode: 'string', precision: 53, scale: 18 }).notNull(),

PercentCompleteAll: decimal({ mode: 'string', precision: 39, scale: 12 }).notNull(),

DateFirstInstall: date({ mode: 'string' }),

DateLastInstall: date({ mode: 'string' }),

RecordLastUpdated: datetime({ mode: 'string' }).notNull(),
});

// #endregion

